/**
 * This is a clone from https://otd.appsonrent.com/on-time-delivery/assets/js/on-time-delivery.js
 * Where the original only loads the date picker on the cart page this version works in the drawer
 */

var OTD_SITE_URL,
  SERVER_PATH,
  Scripturl,
  res,
  res1,
  OTD_scid,
  SITE_FILE_URL,
  OTD_local = 0,
  OTD_path = __st.pageurl,
  OTD_cart = OTD_path.search("/cart"),
  OTD_product = OTD_path.search("/products/"),
  OTD_shopName = Shopify.shop;
1 == OTD_local
  ? ((SITE_FILE_URL =
      "http://localhost/appsonrent-apps/on-time-delivery/on-time-delivery.php"),
    (OTD_SITE_URL = OTD_path =
      "http://localhost/appsonrent-apps/on-time-delivery/"))
  : ((SERVER_PATH = document.currentScript.src.includes("devodd") ? "dev" : ""),
    (OTD_path = "https://otd.appsonrent.com/on-time-delivery/"),
    (OTD_scid =
      void 0 === document.currentScript
        ? ""
        : 1 < (res = (Scripturl = document.currentScript.src).split("&")).length
          ? (res1 = res[1].split("="))[1]
          : ""),
    (SITE_FILE_URL = OTD_path + "on-time-delivery.php"));
var OTD_minDate,
  OTD_min_date,
  OTD_maxDate,
  OTD_currentDate,
  OTD_data,
  OTD_loadCount = 0,
  on_time_required_delivery_date = "",
  on_time_use_time_option = "",
  on_time_appsStatus = 0,
  sp_settings = "",
  oddLocationCalanderSettings = [],
  OTD_delivery_days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  oddStorePickup = "",
  oddItemsData = [],
  OTD_map_load = 0,
  map_js_load = 0,
  OTD_resultJson = "",
  OTD_eddResultJson = "",
  jQueryOTD = "",
  scriptsOTD = [],
  OTD_currentTime = "",
  OTD_deliveryTimeArr = [],
  OTD_daysArr = [],
  OTD_weekDays = [],
  OTD_formatedDisableDateArr = [],
  OTD_formatedDisableDayArr = [];
window.Checkout &&
  window.Checkout.jQuery &&
  (jQueryOTD = window.Checkout.jQuery);
{
  function IW_dt_loadJavascriptAsynch(e) {
    if (jQueryOTD && !e) IW_dt_handler()
    var t = document.createElement("script");
    return (
      (t.type = "text/javascript"),
      (t.src = e),
      t.readyState
        ? (t.onreadystatechange = function () {
            ("complete" != this.readyState && "loaded" != this.readyState) ||
              ((t.onreadystatechange = null),
              (jQueryOTD = window.jQuery),
              console.log("IE jquery load OTD"),
              IW_dt_handler());
          })
        : (t.onload = function () {
            ((jQueryOTD = window.jQuery),
              console.log("App jquery load OTD"),
              IW_dt_handler());
          }),
      void 0 !== t && document.getElementsByTagName("head")[0].appendChild(t),
      t
    );
  }
  function IW_dt_handler() {
    var e, t;
    ++OTD_loadCount < scriptsOTD.length
      ? IW_dt_loadJavascriptAsynch(scriptsOTD[OTD_loadCount])
      : (!jQueryOTD.fn.bootstrapDP &&
          jQueryOTD.fn.datepicker &&
          jQueryOTD.fn.datepicker.noConflict &&
          ((e = jQueryOTD.fn.datepicker.noConflict()),
          (jQueryOTD.fn.bootstrapDP = e)),
        (e = __st.pageurl),
        jQueryOTD("form[action*='/cart']").length ||
        jQueryOTD("form[action='/cart?locale=en']").length
          ? display_calendar_onTime()
          : (t = setInterval(function () {
              (jQueryOTD("form[action*='/cart']").length ||
                jQueryOTD("form[action='/cart?locale=en']").length) &&
                (clearInterval(t), display_calendar_onTime());
            }, 200))
        (0 < OTD_product || "product" == __st.p) &&
            estimated_delivery_date());
  }
  function IW_dt_load_css() {
    (($font_awesome =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css"),
      IW_dt_urlExists($font_awesome, function (e) {
        LoadStyle(e ? $font_awesome : OTD_path + "assets/css/font-awesome.css");
      }),
      LoadStyle(
        OTD_path + "assets/css/on-time_delivery-bootstrap-datepicker3.css",
      ),
      LoadStyle(OTD_path + "assets/css/on-time-delivery.min.css"));
  }
  function IW_dt_urlExists(e, t) {
    var a = new XMLHttpRequest();
    ((a.onreadystatechange = function () {
      4 === a.readyState && t(200 == a.status);
    }),
      a.open("HEAD", e),
      a.send());
  }
  function LoadStyle(e) {
    var t = document.getElementsByTagName("head")[0],
      a = document.createElement("link");
    ((a.rel = "stylesheet"),
      (a.type = "text/css"),
      (a.href = e),
      (a.media = "all"),
      t.appendChild(a));
  }
  function oddJsLoad(e, t) {
    var a;
    document.getElementById(t) ||
      (((a = document.createElement("script")).type = "text/javascript"),
      (a.async = !1),
      (a.src = e),
      (a.id = t),
      (t = document.getElementsByTagName("script")[0]).parentNode.insertBefore(
        a,
        t,
      ));
  }
  
    ("east-lothian-deli-box.myshopify.com" == OTD_shopName ||
    "balloon-up-online.myshopify.com" == OTD_shopName ||
    "wagyu-mall-online.myshopify.com" == OTD_shopName ||
    "chapa-esa-flor.myshopify.com" == OTD_shopName ||
    "soul-souper.myshopify.com" == OTD_shopName ||
    "my-mums-cookies.myshopify.com" == OTD_shopName ||
    "granville-island-delivery-company.myshopify.com" == OTD_shopName ||
    "hydrocleann.myshopify.com" == OTD_shopName ||
    "grocery2u-ca.myshopify.com" == OTD_shopName ||
    "homefield-grange-at-home.myshopify.com" == OTD_shopName ||
    "cut-butchery.myshopify.com" == OTD_shopName ||
    "3eee7e-2.myshopify.com" == OTD_shopName ||
    "birchtree-at-home.myshopify.com" == OTD_shopName ||
    "yippiii.myshopify.com" == OTD_shopName
      ? (console.log("iff enter"),
        (OTD_loadCount = 1),
        (scriptsOTD = [
          OTD_path + "assets/js/jquery-1.12.4.js",
          OTD_path + "assets/js/on-time-delivery-bootstrap-datepicker.js",
        ]),
        window.jQuery ||
          "hydrocleann.myshopify.com" != OTD_shopName ||
          (OTD_loadCount = 0),
        IW_dt_loadJavascriptAsynch(scriptsOTD[OTD_loadCount]),
        IW_dt_load_css())
      : "undefined" == typeof jQuery
        ? (console.log("jquery undefined"),
          IW_dt_loadJavascriptAsynch(
            (scriptsOTD = [
              OTD_path + "assets/js/jquery-1.12.4.js",
              OTD_path + "assets/js/on-time-delivery-bootstrap-datepicker.js",
            ])[OTD_loadCount],
          ),
          IW_dt_load_css())
        : (console.log("App datepicker load"),
          "product" == __st.p
            ? "undefined" != typeof jQuery ||
              ("halal-with-hew.myshopify.com" == OTD_shopName &&
                "rachelefiori1977.myshopify.com" == OTD_shopName &&
                "homeward-bound-pet-food-delivery-halifax.myshopify.com" ==
                  OTD_shopName &&
                "natalia-s-rustic-kitchen.myshopify.com" == OTD_shopName &&
                "feyarozy.myshopify.com" == OTD_shopName &&
                "interflora-toluca.myshopify.com" == OTD_shopName &&
                "douart-bakery.myshopify.com" == OTD_shopName &&
                "so-fresh-bakehouse.myshopify.com" == OTD_shopName &&
                "balsamine-atelier.myshopify.com" == OTD_shopName &&
                "alyusoff-sg.myshopify.com" == OTD_shopName &&
                "sweetnnice.myshopify.com" == OTD_shopName &&
                "warsaw-balloonmakers.myshopify.com" == OTD_shopName)
              ? (console.log("product page"),
                (jQueryOTD = window.jQuery),
                IW_dt_handler())
              : (console.log("product page"),
                scriptsOTD.push(OTD_path + "assets/js/jquery_2.2.3.min.js"),
                IW_dt_loadJavascriptAsynch(scriptsOTD[OTD_loadCount]),
                IW_dt_load_css())
            : 0 < OTD_cart &&
              OTD_product < 0 &&
              (console.log("cart page"),
              scriptsOTD.push(OTD_path + "assets/js/jquery-1.12.4.js"),
              scriptsOTD.push(
                OTD_path + "assets/js/on-time-delivery-bootstrap-datepicker.js",
              ),
              IW_dt_loadJavascriptAsynch(scriptsOTD[OTD_loadCount]),
              IW_dt_load_css())));
}
function display_calendar_onTime() {
  jQueryOTD.ajax({
    type: "GET",
    url: "/cart.json",
    dataType: "json",
    async: !1,
    success: function (e) {
      var t = e.items;
      if (0 == t.length) return !0;
      for (var a = 0; a < t.length; a++) oddItemsData.push(t[a].product_id);
      e = {};
      ((e.scid = OTD_scid),
        (e.shop = OTD_shopName),
        (e.cartData = oddItemsData),
        (e.method_name = "get_shipping_data"),
        jQueryOTD.ajax({
          type: "POST",
          url: SITE_FILE_URL,
          data: e,
          success: function (e) {
            var t = [
              "cart-form",
              "cart",
              "cart_form",
              "CartPageForm",
              "",
              "site-cart-form-page",
              "updateform",
              "cartform",
              "cml_checkout_form",
              "cartForm",
              "frm-cart",
            ];
            if (
              "0" == (OTD_resultJson = JSON.parse(e)).date_picker_status ||
              "0" == OTD_resultJson.charge_approve
            )
              return !0;
            if (
              "success" == OTD_resultJson.msg &&
              "1" == OTD_resultJson.charge_approve
            ) {
              var a,
                r = OTD_resultJson.max_days,
                i = OTD_resultJson.min_day_value;
              if (
                "1" == OTD_resultJson.plan_type &&
                "1" == OTD_resultJson.sp_app_status
              ) {
                if (
                  (oddJsLoad(
                    OTD_path + "assets/js/store_pickup.js",
                    "otdStorePickupJs",
                  ),
                  (sp_settings = OTD_resultJson.sp_setting.sp_settings_data),
                  0 < jQueryOTD(".iweb-order-delivery-dt-pro").length)
                )
                  (jQueryOTD(".iweb-order-delivery-dt-pro").html(
                    OTD_resultJson.sp_setting_html,
                  ),
                    setInterval(() => {
                      document.querySelectorAll(".iweb-order-delivery-dt-pro")
                        ?.length &&
                        !document.querySelectorAll(
                          ".iweb-order-delivery-dt-pro .appsonrent-dds-main",
                        )?.length &&
                        !document.querySelectorAll(".storePickupTab.active_tab")
                          .length &&
                        OTD_resultJson.sp_setting_html &&
                        (jQueryOTD(".iweb-order-delivery-dt-pro").html(
                          OTD_resultJson.sp_setting_html,
                        ),
                        shipping_calender_show(r, i));
                    }, 100));
                else {
                  let e =
                    (a = jQueryOTD(
                      "form[action*='/cart']:not(form[action='/cart/add']),form[action='/cart?locale=en']:not(form[action='/cart/add'])",
                    ))?.length || 0;
                  for (; e--; ) {
                    var s = a[e];
                    t.includes(s.id) &&
                      (((d = document.createElement("div")).className =
                        "iweb-order-delivery-dt-pro"),
                      s.appendChild(d),
                      jQueryOTD(".iweb-order-delivery-dt-pro").append(
                        OTD_resultJson.sp_setting_html,
                      ));
                  }
                }
                if ("1" == OTD_resultJson.shipping_status)
                  return (shipping_calender_show(r, i), !0);
              } else {
                if (0 < jQueryOTD(".iweb-order-delivery-dt-pro").length)
                  (jQueryOTD(".iweb-order-delivery-dt-pro").append(
                    "<div class='iw-order-delivery-dt-main'><div class='otd_container'></div></div>",
                  ),
                    setInterval(() => {
                      document.querySelectorAll(".iweb-order-delivery-dt-pro")
                        ?.length &&
                        !document.querySelectorAll(
                          ".iweb-order-delivery-dt-pro .iw-order-delivery-dt-main",
                        )?.length &&
                        (jQueryOTD(".iweb-order-delivery-dt-pro").html(
                          "<div class='iw-order-delivery-dt-main'><div class='otd_container'></div></div>",
                        ),
                        shipping_calender_show(r, i, 1));
                    }, 100));
                else if (!jQueryOTD(".iweb-order-delivery-dt-pro").length) {
                  let e =
                    (a = jQueryOTD(
                      "form[action*='/cart']:not(form[action='/cart/add']),form[action='/cart?locale=en']:not(form[action='/cart/add'])",
                    ))?.length || 0;
                  for (; e--; ) {
                    var d,
                      o,
                      s = a[e];
                    t.includes(s.id) &&
                      ((d = document.createElement("div")),
                      ((o = document.createElement("div")).className =
                        "otd_container"),
                      (d.className = "iw-order-delivery-dt-main"),
                      d.append(o),
                      s.appendChild(d));
                  }
                }
                e = OTD_resultJson.custom_css;
                e &&
                  jQueryOTD(".iw-order-delivery-dt-main").append(
                    "<style>" + e + "</style>",
                  );
              }
              if (
                (jQueryOTD(
                  "<div class='calendar_heading' style='text-align:center'>" +
                    OTD_resultJson.calendar_heading +
                    "</div>",
                ).insertBefore(".iw-order-delivery-dt-pro"),
                "1" == OTD_resultJson.date_picker_status &&
                  (jQueryOTD(
                    'form[action*="/cart"] [name="checkout"],form[action="/cart?locale=en"] [name="checkout"]',
                  ).removeAttr("disabled"),
                  "1" == OTD_resultJson.shipping_status))
              )
                return (shipping_calender_show(r, i, 1), !0);
            }
          },
        }));
    },
  });
}
function estimated_delivery_date() {
  var e;
  jQueryOTD("form[action*='/cart/add']") &&
    "product" == __st.p &&
    (((e = {}).scid = OTD_scid),
    (e.shop = OTD_shopName),
    (e.method_name = "getSettings"),
    (e.new_method = "eddSettings"),
    jQueryOTD.ajax({
      type: "POST",
      url: SITE_FILE_URL,
      data: e,
      success: function (e) {
        var h,
          r,
          i,
          t,
          a,
          v,
          g,
          b,
          s,
          d,
          o,
          n,
          _,
          l,
          j,
          w,
          m,
          u,
          Q,
          c,
          D,
          p,
          y,
          T,
          x,
          O,
          A,
          I,
          f,
          S,
          J,
          k,
          R,
          F,
          L,
          C,
          N,
          M,
          q,
          P,
          E,
          V,
          H,
          W,
          z;
        ((e = JSON.parse(e)),
          (OTD_eddResultJson = e.data),
          void 0 !== e.data &&
            "success" == e.msg &&
            "0" != e.date_picker_status &&
            "0" != e.charge_approve &&
            OTD_eddResultJson.date_picker_status &&
            "1" == OTD_eddResultJson.date_picker_status &&
            jQueryOTD("form[action*='/cart/add']") &&
            ((h = jQueryOTD("form[action*='/cart/add']")),
            "1" == OTD_eddResultJson.show_edd_datetime &&
              ((a = []),
              (n = (D = new Date(
                OTD_eddResultJson.timezonecurrenttime24,
              )).getMinutes()),
              (c = D.getHours() + ":" + n),
              (p = OTD_eddResultJson.cutoff_time),
              (OTD_currentDate = dateObjToString(D)),
              (OTD_currentTime = dateObjToTimeString(D)),
              (e = OTD_eddResultJson.min_day_value),
              "object" == typeof (OTD_min_date = addDays(OTD_currentDate, e)) &&
                (OTD_min_date =
                  OTD_min_date.getFullYear() +
                  "-" +
                  (t = (t = OTD_min_date.getMonth() + 1) < 10 ? "0" + t : t) +
                  "-" +
                  (OTD_min_date.getDate() < 10
                    ? "0" + OTD_min_date.getDate()
                    : OTD_min_date.getDate())),
              (r = find_separator_date(
                (OTD_minDate = OTD_eddResultJson.min_date),
              )),
              (n = find_separator_date((i = OTD_eddResultJson.date_format))),
              (OTD_minDate = dateFormatConvert(
                i,
                "yy-mm-dd",
                r,
                "-",
                OTD_minDate,
              )),
              (e = parseInt(OTD_eddResultJson.max_date)),
              (t = new Date(OTD_minDate)),
              (t =
                (t = (t = (OTD_maxDate = addDays(t, e)).getDate()).toString())
                  .length < 2
                  ? "0".concat(t)
                  : t),
              (e =
                (e = (OTD_maxDate.getMonth() + 1).toString()).length < 2
                  ? "0".concat(e)
                  : e),
              (OTD_maxDate = OTD_maxDate.getFullYear() + "-" + e + "-" + t),
              "" !== (a = OTD_eddResultJson.extra_no_available.split(","))[0] &&
                a.forEach(function (e) {
                  e = dateFormatConvert(i, "yy-mm-dd", r, "-", e);
                  var t = new Date(e),
                    a = t.getFullYear(),
                    e = (e = t.getMonth() + 1) < 10 ? "0" + e : e,
                    t = t.getDate() < 10 ? "0" + t.getDate() : t.getDate();
                  OTD_formatedDisableDateArr.push(a + "-" + e + "-" + t);
                }),
              (OTD_minDate = recursiveOnDisableDates(
                OTD_minDate,
                OTD_formatedDisableDateArr,
              )),
              (a = OTD_eddResultJson.invalid_day),
              (OTD_formatedDisableDayArr = a.split(",")),
              (OTD_minDate = recursiveOnDisableDays(
                OTD_minDate,
                OTD_formatedDisableDayArr,
                OTD_formatedDisableDateArr,
              )),
              (holiday_minDate =
                "1" == OTD_eddResultJson.required_holiday_interval
                  ? OTD_minDate
                  : ""),
              (v = OTD_eddResultJson.timer_status_format),
              "NULL" !== OTD_eddResultJson.timer_status_format &&
                ((W = date_change_onTimeDel_function_edd(
                  OTD_minDate,
                  i,
                  n,
                  OTD_eddResultJson,
                )),
                (OTD_deliveryTimeArr = W.tempObj_12),
                (deliveryTimeArr_24 = W.tempObj_24),
                null != deliveryTimeArr_24 &&
                0 == Object.keys(deliveryTimeArr_24).length
                  ? ((OTD_minDate =
                      "object" ==
                      typeof (OTD_minDate = recursiveOnDisableDays(
                        (OTD_minDate = recursiveOnDisableDates(
                          (OTD_minDate = addDays(OTD_minDate, 1)),
                          OTD_formatedDisableDateArr,
                        )),
                        OTD_formatedDisableDayArr,
                        OTD_formatedDisableDateArr,
                      ))
                        ? dateObjToString(OTD_minDate)
                        : OTD_minDate),
                    (OTD_deliveryTimeArr =
                      OTD_eddResultJson.delivery_time.time_24),
                    (deliveryTimeArr_24 = OTD_eddResultJson.delivery_time.time))
                  : null != deliveryTimeArr_24 &&
                      0 == Object.keys(W.tempObj_12).length &&
                      0 == Object.keys(deliveryTimeArr_24).length
                    ? (OTD_deliveryTimeArr = W)
                    : null != deliveryTimeArr_24 &&
                      0 == Object.keys(W.tempObj_12).length &&
                      0 != Object.keys(deliveryTimeArr_24).length &&
                      (OTD_deliveryTimeArr = W.tempObj_24)),
              "NULL" == OTD_eddResultJson.timer_status_format &&
                "1" == OTD_eddResultJson.cutoff_time_status &&
                ((_ = OTD_eddResultJson.cutoff_time),
                (l = []),
                OTD_minDate == OTD_currentDate
                  ? 0 ==
                      (d = recursiveOnDeliveryTime_cutoff_zero(
                        _,
                        OTD_deliveryTimeArr,
                        "cutoff",
                      )).length &&
                    (OTD_minDate =
                      "object" ==
                      typeof (OTD_minDate = recursiveOnDisableDays(
                        (OTD_minDate = recursiveOnDisableDates(
                          (OTD_minDate = addDays(OTD_minDate, 1)),
                          OTD_formatedDisableDateArr,
                        )),
                        OTD_formatedDisableDayArr,
                        OTD_formatedDisableDateArr,
                      ))
                        ? dateObjToString(OTD_minDate)
                        : OTD_minDate)
                  : OTD_minDate == OTD_min_date &&
                    1 == OTD_eddResultJson.cutoff_time_min_day &&
                    0 ==
                      (d = recursiveOnDeliveryTime_cutoff_zero(
                        _,
                        OTD_deliveryTimeArr,
                        "cutoff",
                      )).length &&
                    (OTD_minDate =
                      "object" ==
                      typeof (OTD_minDate = recursiveOnDisableDays(
                        (OTD_minDate = recursiveOnDisableDates(
                          (OTD_minDate = addDays(OTD_minDate, 1)),
                          OTD_formatedDisableDateArr,
                        )),
                        OTD_formatedDisableDayArr,
                        OTD_formatedDisableDateArr,
                      ))
                        ? dateObjToString(OTD_minDate)
                        : OTD_minDate)),
              "0" == v
                ? (OTD_minDate == OTD_currentDate &&
                    (OTD_minDate =
                      "object" ==
                      typeof (OTD_minDate = recursiveOnDisableDays(
                        (OTD_minDate = recursiveOnDisableDates(
                          OTD_minDate,
                          OTD_formatedDisableDateArr,
                        )),
                        OTD_formatedDisableDayArr,
                        OTD_formatedDisableDateArr,
                      ))
                        ? dateObjToString(OTD_minDate)
                        : OTD_minDate),
                  "1" == OTD_eddResultJson.cutoff_time_status &&
                    ((_ = OTD_eddResultJson.cutoff_time),
                    (l = []),
                    OTD_minDate == OTD_currentDate
                      ? (0 ==
                        (d = recursiveOnDeliveryTime_cutoff_zero(
                          _,
                          OTD_deliveryTimeArr,
                          "cutoff",
                        )).length
                          ? ((OTD_minDate =
                              "object" ==
                              typeof (OTD_minDate = recursiveOnDisableDays(
                                (OTD_minDate = recursiveOnDisableDates(
                                  (OTD_minDate = addDays(OTD_minDate, 1)),
                                  OTD_formatedDisableDateArr,
                                )),
                                OTD_formatedDisableDayArr,
                                OTD_formatedDisableDateArr,
                              ))
                                ? dateObjToString(OTD_minDate)
                                : OTD_minDate),
                            OTD_min_date < OTD_minDate &&
                              (l = defaultDeliveryTimes))
                          : (l = d),
                        0 == l.length &&
                          (OTD_minDate =
                            "object" ==
                            typeof (OTD_minDate = recursiveOnDisableDays(
                              (OTD_minDate = recursiveOnDisableDates(
                                (OTD_minDate = addDays(OTD_minDate, 1)),
                                OTD_formatedDisableDateArr,
                              )),
                              OTD_formatedDisableDayArr,
                              OTD_formatedDisableDateArr,
                            ))
                              ? dateObjToString(OTD_minDate)
                              : OTD_minDate))
                      : OTD_minDate == OTD_min_date &&
                        1 == OTD_eddResultJson.cutoff_time_min_day &&
                        ((d = recursiveOnDeliveryTime_cutoff_zero(
                          _,
                          OTD_deliveryTimeArr,
                          "cutoff",
                        )),
                        0 < l.length &&
                          (OTD_minDate =
                            "object" ==
                            typeof (OTD_minDate = recursiveOnDisableDays(
                              (OTD_minDate = recursiveOnDisableDates(
                                OTD_minDate,
                                OTD_formatedDisableDateArr,
                              )),
                              OTD_formatedDisableDayArr,
                              OTD_formatedDisableDateArr,
                            ))
                              ? dateObjToString(OTD_minDate)
                              : OTD_minDate),
                        0 == d.length &&
                          (OTD_minDate =
                            "object" ==
                            typeof (OTD_minDate = recursiveOnDisableDays(
                              (OTD_minDate = recursiveOnDisableDates(
                                (OTD_minDate = addDays(OTD_minDate, 1)),
                                OTD_formatedDisableDateArr,
                              )),
                              OTD_formatedDisableDayArr,
                              OTD_formatedDisableDateArr,
                            ))
                              ? dateObjToString(OTD_minDate)
                              : OTD_minDate))))
                : "1" == v
                  ? ((daysArray = [
                      "sunday",
                      "monday",
                      "tuesday",
                      "wednesday",
                      "thursday",
                      "friday",
                      "saturday",
                    ]),
                    (n = (D = new Date(OTD_minDate)).getDay()),
                    (n = daysArray[n]),
                    (g = (W = OTD_eddResultJson.delivery_time)[n].start_time),
                    (b = W[n].end_time),
                    (b =
                      12 == OTD_eddResultJson.time_display_format
                        ? ((g = oddt_convert_24_to_12(g[0].split(":"))),
                          oddt_convert_24_to_12(b[0].split(":")))
                        : ((g = g[0]), b[0])),
                    OTD_eddResultJson.order_data,
                    (s = []),
                    OTD_minDate == OTD_currentDate &&
                      (jQueryOTD.each(OTD_deliveryTimeArr, function (e, t) {
                        OTD_currentTime < t && s.push(t);
                      }),
                      0 < s.length
                        ? (OTD_deliveryTimeArr = s)
                        : 0 == s.length &&
                          ((OTD_minDate =
                            "object" ==
                            typeof (OTD_minDate = recursiveOnDisableDays(
                              (OTD_minDate = recursiveOnDisableDates(
                                (OTD_minDate =
                                  "object" ==
                                  typeof (OTD_minDate = addDays(OTD_minDate, 1))
                                    ? dateObjToString(OTD_minDate)
                                    : OTD_minDate),
                                OTD_formatedDisableDateArr,
                              )),
                              OTD_formatedDisableDayArr,
                              OTD_formatedDisableDateArr,
                            ))
                              ? dateObjToString(OTD_minDate)
                              : OTD_minDate),
                          (o = (D = new Date(OTD_minDate)).getDay()),
                          (n = daysArray[o]),
                          (OTD_deliveryTimeArr = W[n].start_time))),
                    "1" == OTD_eddResultJson.cutoff_time_status &&
                      ((_ = OTD_eddResultJson.cutoff_time),
                      (l = []),
                      dateObjToString(addDays(OTD_currentDate, 1)),
                      (OTD_deliveryTimeArr = W[n].start_time),
                      OTD_minDate == OTD_currentDate
                        ? (0 <
                            (d = recursiveOnDeliveryTime_cutoff_one(
                              _,
                              OTD_deliveryTimeArr,
                              "cutoff",
                            )).length && (OTD_deliveryTimeArr = d),
                          0 == d.length &&
                            ((OTD_minDate =
                              "object" ==
                              typeof (OTD_minDate = recursiveOnDisableDays(
                                (OTD_minDate = recursiveOnDisableDates(
                                  (OTD_minDate =
                                    "object" ==
                                    typeof (OTD_minDate = addDays(
                                      OTD_minDate,
                                      1,
                                    ))
                                      ? dateObjToString(OTD_minDate)
                                      : OTD_minDate),
                                  OTD_formatedDisableDateArr,
                                )),
                                OTD_formatedDisableDayArr,
                                OTD_formatedDisableDateArr,
                              ))
                                ? dateObjToString(OTD_minDate)
                                : OTD_minDate),
                            (o = (D = new Date(OTD_minDate)).getDay()),
                            (n = daysArray[o]),
                            (OTD_deliveryTimeArr = W[n].start_time)))
                        : OTD_minDate == OTD_min_date &&
                          "1" == OTD_eddResultJson.cutoff_time_min_day &&
                          ((OTD_minDate =
                            "object" ==
                            typeof (OTD_minDate = recursiveOnDisableDays(
                              (OTD_minDate = recursiveOnDisableDates(
                                (OTD_minDate =
                                  "object" ==
                                  typeof (OTD_minDate = addDays(OTD_minDate, 1))
                                    ? dateObjToString(OTD_minDate)
                                    : OTD_minDate),
                                OTD_formatedDisableDateArr,
                              )),
                              OTD_formatedDisableDayArr,
                              OTD_formatedDisableDateArr,
                            ))
                              ? dateObjToString(OTD_minDate)
                              : OTD_minDate),
                          (o = (D = new Date(OTD_minDate)).getDay()),
                          (n = daysArray[o]),
                          (OTD_deliveryTimeArr = W[n].start_time))))
                  : "2" == v &&
                    "1" == OTD_eddResultJson.cutoff_time_status &&
                    ((_ = OTD_eddResultJson.cutoff_time),
                    (l = []),
                    OTD_minDate == OTD_currentDate
                      ? parseFloat(c) >= parseFloat(p) &&
                        (OTD_minDate =
                          "object" ==
                          typeof (OTD_minDate = recursiveOnDisableDays(
                            (OTD_minDate = recursiveOnDisableDates(
                              (OTD_minDate = addDays(OTD_minDate, 1)),
                              OTD_formatedDisableDateArr,
                            )),
                            OTD_formatedDisableDayArr,
                            OTD_formatedDisableDateArr,
                          ))
                            ? dateObjToString(OTD_minDate)
                            : OTD_minDate)
                      : OTD_minDate == OTD_min_date &&
                        1 == OTD_eddResultJson.cutoff_time_min_day &&
                        parseFloat(c) >= parseFloat(p) &&
                        (OTD_minDate =
                          "object" ==
                          typeof (OTD_minDate = recursiveOnDisableDays(
                            (OTD_minDate = recursiveOnDisableDates(
                              (OTD_minDate = addDays(OTD_minDate, 1)),
                              OTD_formatedDisableDateArr,
                            )),
                            OTD_formatedDisableDayArr,
                            OTD_formatedDisableDateArr,
                          ))
                            ? dateObjToString(OTD_minDate)
                            : OTD_minDate)),
              "string" == typeof OTD_minDate
                ? (OTD_minDate.includes("-") ||
                    OTD_minDate.includes("/") ||
                    OTD_minDate.includes(".")) &&
                  (j = OTD_minDate)
                : "object" == typeof OTD_minDate &&
                  (j = dateObjToString(OTD_minDate)),
              (c = find_separator_date(j)),
              (w = j.split(c)),
              "2" == v && null != OTD_deliveryTimeArr
                ? (m = OTD_deliveryTimeArr)
                : ((u = []), (u = OTD_deliveryTimeArr)),
              (OTD_daysArr =
                "" != OTD_eddResultJson.dates_name
                  ? OTD_eddResultJson.months_name.split(",")
                  : [
                      "Jan",
                      "Fab",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ]),
              (OTD_weekDays =
                "" != OTD_eddResultJson.months_name
                  ? OTD_eddResultJson.dates_name.split(",")
                  : [
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ]),
              j.includes("/") &&
                "string" == typeof j &&
                (j = (j = j.replaceAll("/", "-"))
                  .split("-")
                  .reverse()
                  .join("-")),
              (p = new Date(j)),
              (Q = OTD_weekDays[p.getDay()]),
              "24" == OTD_eddResultJson.time_display_format &&
                "1" == v &&
                ((weekDay_24 = ""),
                (c = u[0].split("-")),
                (f = (D = new Date(OTD_minDate)).getDay()),
                (p = daysArray[f]),
                (weekDay_24 = OTD_weekDays[D.getDay()]),
                (f = OTD_eddResultJson.delivery_time[p].start_time),
                (y = OTD_eddResultJson.delivery_time[p].end_time),
                (T = f.indexOf(c[0])),
                (finalStartDeliveryTime_24 = []),
                (finalEndDeliveryTime_24 = []),
                jQueryOTD.each(f, function (e, t) {
                  T == e &&
                    (finalStartDeliveryTime_24.push(t),
                    finalEndDeliveryTime_24.push(y[e]));
                })),
              (x = OTD_eddResultJson.edd_editor_text),
              (O = $("<div/>")),
              x &&
                "" != x &&
                ((S = $("<div/>").html(x)),
                $(S[0])
                  .children()
                  .each(function (e, t) {
                    $(t)[0].textContent.includes("{{timer_day_hour}}") ||
                    $(t)[0].textContent.includes("{{day_hour}}") ||
                    $(t)[0].textContent.includes("{{date_time}}")
                      ? ($(t)[0].textContent.includes("{{timer_day_hour}}") &&
                          ($(t).addClass("edd_timerDayHour_class"),
                          O.append($(t)[0])),
                        $(t)[0].textContent.includes("{{day_hour}}") &&
                          ($(t).addClass("edd_dayHour_class"),
                          O.append($(t)[0])),
                        $(t)[0].textContent.includes("{{date_time}}") &&
                          ($(t).addClass("edd_dateTime_class"),
                          O.append($(t)[0])))
                      : O.append($(t)[0]);
                  }),
                (x = O[0].innerHTML)),
              (A = ""),
              "2" !== v
                ? x &&
                  "" != x &&
                  ((I = j.split("-")),
                  "" != u &&
                    (1 == v && void 0 !== deliveryTimeArr_24
                      ? ((f = (z = deliveryTimeArr_24[0].split("-"))[0].split(
                          ":",
                        )),
                        (S = z[1].split(":")),
                        (z[0] = f[0].length < 2 ? "0".concat(f[0]) : f[0]),
                        (z[1] = S[0].length < 2 ? "0".concat(S[0]) : S[0]),
                        (J = f))
                      : 0 == v &&
                        (((z = deliveryTimeArr_24[0].split(":"))[0] =
                          z[0].length < 2 ? "0".concat(z[0]) : z[0]),
                        (z[1] = z[1].length < 2 ? "0".concat(z[1]) : z[1]),
                        ((J = u[0].split(":"))[0] =
                          J[0].length < 2 ? "0".concat(J[0]) : J[0]),
                        (J[1] = J[1].length < 2 ? "0".concat(J[1]) : J[1])),
                    (A = void 0 !== z ? z[0] : "")),
                  (k = ["{{timer_day_hour}}", "{{day_hour}}", "{{date_time}}"]),
                  (R = new Date(I[0], I[1] - 1, I[2], A).getTime()),
                  (E = P = q = M = N = C = L = F = 0),
                  (V = setInterval(function () {
                    var e = new Date().getTime(),
                      t = R - e;
                    (t < 0 &&
                      (t =
                        new Date(
                          I[0],
                          I[1] - 1,
                          Number(I[2]) + 2,
                          A,
                        ).getTime() - e),
                      (F = Math.floor(t / 864e5)),
                      (L = Math.floor((t % 864e5) / 36e5)),
                      (C = Math.floor((t % 36e5) / 6e4)),
                      (N = Math.floor((t % 6e4) / 1e3)));
                    var a,
                      r,
                      i,
                      s,
                      d,
                      o,
                      n,
                      _,
                      l,
                      m,
                      u,
                      c,
                      D,
                      p,
                      y,
                      T,
                      O,
                      f = F < 10 ? "0" + F.toString() : F.toString(),
                      e = L < 10 ? "0" + L.toString() : L.toString();
                    (C.toString(), N.toString());
                    ((M = f ? f.charAt(0) : "0"),
                      (q = f ? f.charAt(1) : "0"),
                      (P = e ? e.charAt(0) : "0"),
                      (E = e ? e.charAt(1) : "0"),
                      jQueryOTD(document).find("#main_content").length
                        ? ((r =
                            "display: flex; font-weight: 600; border-radius: 10%; justify-content: center;"),
                          (i =
                            "color: #000000;font-size : " +
                            OTD_eddResultJson.edd_timer_appearance
                              .edd_timer_font_size +
                            "px"),
                          (s = ""),
                          "NULL" !== OTD_eddResultJson.timer_status_format &&
                            (s =
                              '<span class="edd_time_container_js" style="display: flex; margin-left: 10px; align-items: baseline;"><span class="edd_timer_days_items edd_timer_item" style="text-align: center;"><span style="display: flex;"><span class="position"><span class="timer_digit timer_digit_hourOne" style="' +
                              r +
                              '">' +
                              M +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_hourTwo" style="' +
                              r +
                              '">' +
                              q +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Days</span></span><span class="edd_timer_separator" style="' +
                              i +
                              '">:</span><span class="edd_timer_hour_items edd_timer_item" style="text-align: center;"><span style = "display:flex;"><span class="position"><span class="timer_digit timer_digit_minOne" style="' +
                              r +
                              '">' +
                              P +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_minTwo" style="' +
                              r +
                              '">' +
                              E +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Hrs</span></span></span>'),
                          (d =
                            0 == F
                              ? (1 < L ? L + " hours " : L + " hour ") +
                                (1 < C ? C + " minutes" : C + " minute")
                              : 0 == L
                                ? (1 < F ? F + " days " : F + " day ") +
                                  (1 < C ? C + " minutes" : C + " minute")
                                : 0 == C
                                  ? (1 < F ? F + " days " : F + " day ") +
                                    (1 < L ? L + " hours " : L + " hour ")
                                  : (1 < F ? F + " days " : F + " day ") +
                                    (1 < L ? L + " hours " : L + " hour ") +
                                    (1 < C ? C + " minutes" : C + " minute")),
                          0 < (c = []).length &&
                            ((c[0] = J[0].toString()),
                            (c[1] = J[1].toString()),
                            c[0].length < 2 && (c[0] = "0".concat(c[0]))),
                          (c = [
                            s,
                            d,
                            "1" == v && 0 < c.length
                              ? ("12" <= c[0] && "12" != c[0] && (c[0] -= 12),
                                c[0].toString().length < 2 &&
                                  (c[0] = "0".concat(c[0])),
                                "1" == OTD_eddResultJson.show_edd_between_dates
                                  ? ((f = (n =
                                      "" != OTD_eddResultJson.dates_name
                                        ? OTD_eddResultJson.dates_name.split(
                                            ",",
                                          )
                                        : [
                                            "Sunday",
                                            "Monday",
                                            "Tuesday",
                                            "Wednesday",
                                            "Thursday",
                                            "Friday",
                                            "Saturday",
                                          ])[new Date(j).getDay()]),
                                    (_ = OTD_minDate.split("-")),
                                    (m =
                                      n[
                                        (l = addDays(
                                          (_ = new Date(_[0], _[1] - 1, _[2])),
                                          OTD_eddResultJson.max_delivery_days,
                                        )).getDay()
                                      ]),
                                    (u = (l = dateObjToString(l)).split("-")),
                                    f +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " - " +
                                      m +
                                      ", " +
                                      u[2] +
                                      " " +
                                      OTD_daysArr[u[1] - 1] +
                                      " " +
                                      u[0])
                                  : "12" ==
                                      OTD_eddResultJson.time_display_format
                                    ? Q +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " - " +
                                      convert_time_24to12(deliveryTimeArr_24[0])
                                    : weekDay_24 +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " - " +
                                      finalStartDeliveryTime_24 +
                                      " - " +
                                      finalEndDeliveryTime_24)
                              : "1" == OTD_eddResultJson.show_edd_between_dates
                                ? ((f = (n =
                                    "" != OTD_eddResultJson.dates_name
                                      ? OTD_eddResultJson.dates_name.split(",")
                                      : [
                                          "Sunday",
                                          "Monday",
                                          "Tuesday",
                                          "Wednesday",
                                          "Thursday",
                                          "Friday",
                                          "Saturday",
                                        ])[new Date(j).getDay()]),
                                  (_ = OTD_minDate.split("-")),
                                  (m =
                                    n[
                                      (l = addDays(
                                        (_ = new Date(_[0], _[1] - 1, _[2])),
                                        OTD_eddResultJson.max_delivery_days,
                                      )).getDay()
                                    ]),
                                  (u = (l = dateObjToString(l)).split("-")),
                                  f +
                                    ", " +
                                    w[2] +
                                    " " +
                                    OTD_daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    " - " +
                                    m +
                                    ", " +
                                    u[2] +
                                    " " +
                                    OTD_daysArr[u[1] - 1] +
                                    " " +
                                    u[0])
                                : 1 == v
                                  ? "12" ==
                                    OTD_eddResultJson.time_display_format
                                    ? ((a =
                                        void 0 !== deliveryTimeArr_24
                                          ? convert_time_24to12(
                                              deliveryTimeArr_24[0],
                                            )
                                          : g + " - " + b),
                                      Q +
                                        ", " +
                                        w[2] +
                                        " " +
                                        OTD_daysArr[w[1] - 1] +
                                        " " +
                                        w[0] +
                                        " - " +
                                        a)
                                    : weekDay_24 +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " - " +
                                      finalStartDeliveryTime_24 +
                                      " - " +
                                      finalEndDeliveryTime_24
                                  : ((o = ""),
                                    void 0 !== J &&
                                      (o = " - " + J[0] + ":" + J[1]),
                                    Q +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      o),
                          ]),
                          x &&
                            "" != x &&
                            (p = (D = x.includes(k[0])
                              ? x.replaceAll(k[0], c[0])
                              : x).includes(k[1])
                              ? D.replaceAll(k[1], c[1])
                              : D).includes(k[2]) &&
                            (p = p.replaceAll(k[2], c[2])),
                          jQueryOTD(document).find("#main_content").html(p),
                          jQueryOTD(document)
                            .find("#main_content .edd_timeDayHour_class")
                            .css("display", "block"),
                          jQueryOTD(document)
                            .find(".edd_time_container_js")
                            .attr(
                              "style",
                              "display: inline-flex; align-items: baseline;",
                            ),
                          "NULL" == OTD_eddResultJson.timer_status_format &&
                            ($(".edd_timerDayHour_class").remove(),
                            $(".edd_dayHour_class").remove()),
                          OTD_eddResultJson.edd_datetime_margin &&
                            ((y = OTD_eddResultJson.edd_datetime_margin),
                            jQueryOTD("#main_content").nextAll(
                              ".edd_dateTime_class",
                            ) &&
                              jQueryOTD("#main_content")
                                .nextAll(".edd_dateTime_class")
                                .css({
                                  margin:
                                    y.edd_datetime_margin_top +
                                    "px " +
                                    y.edd_datetime_margin_right +
                                    "px " +
                                    y.edd_datetime_margin_bottom +
                                    "px " +
                                    y.edd_datetime_margin_left +
                                    "px",
                                })),
                          OTD_eddResultJson.edd_timer_margin &&
                            ((T = OTD_eddResultJson.edd_timer_margin),
                            jQueryOTD("#main_content").find(
                              ".edd_timeDayHour_class",
                            ) &&
                              jQueryOTD("#main_content")
                                .find(".edd_timeDayHour_class")
                                .css({
                                  margin:
                                    T.edd_timer_margin_top +
                                    "px " +
                                    T.edd_timer_margin_right +
                                    "px " +
                                    T.edd_timer_margin_bottom +
                                    "px " +
                                    T.edd_timer_margin_left +
                                    "px",
                                })),
                          OTD_eddResultJson.edd_timer_appearance &&
                            ((O = OTD_eddResultJson.edd_timer_appearance),
                            jQueryOTD(".timer_digit").css({
                              "background-color": O.edd_timer_digit_bg_color,
                              color: O.edd_timer_digit_color,
                              "font-size": O.edd_timer_font_size + "px",
                            }),
                            jQueryOTD(".timer_label").css({
                              "font-size": O.edd_timer_label_font_size + "px",
                              "font-weight": O.edd_timer_label_font_weight,
                              color: O.edd_timer_units_label_color,
                            }),
                            jQueryOTD(".edd_timer_separator").css({
                              color: O.edd_timer_separator_color,
                            })))
                        : ((a = []),
                          (r =
                            "display: flex; border-radius: 10%; justify-content: center;"),
                          (i =
                            "color: #000000;font-size : " +
                            OTD_eddResultJson.edd_timer_appearance
                              .edd_timer_font_size +
                            "px"),
                          (s = ""),
                          "NULL" !== OTD_eddResultJson.timer_status_format &&
                            (s =
                              '<span class="edd_time_container_js" style="display: inline-flex; align-items: baseline;"><span class="edd_timer_days_items edd_timer_item" style="text-align: center;"><span style="display: flex;"><span class="position"><span class="timer_digit timer_digit_hourOne" style="' +
                              r +
                              '">' +
                              M +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_hourTwo" style="' +
                              r +
                              '">' +
                              q +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Days</span></span><span class="edd_timer_separator" style="' +
                              i +
                              '">:</span><span class="edd_timer_hour_items edd_timer_item" style="text-align: center;"><span style = "display:flex;"><span class="position"><span class="timer_digit timer_digit_minOne" style="' +
                              r +
                              '">' +
                              P +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_minTwo" style="' +
                              r +
                              '">' +
                              E +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Hrs</span></span></span>'),
                          (d =
                            0 == F
                              ? (1 < L ? L + " hours " : L + " hour ") +
                                (1 < C ? C + " minutes" : C + " minute")
                              : 0 == L
                                ? (1 < F ? F + " days " : F + " day ") +
                                  (1 < C ? C + " minutes" : C + " minute")
                                : 0 == C
                                  ? (1 < F ? F + " days " : F + " day ") +
                                    (1 < L ? L + " hours " : L + " hour ")
                                  : (1 < F ? F + " days " : F + " day ") +
                                    (1 < L ? L + " hours " : L + " hour ") +
                                    (1 < C ? C + " minutes" : C + " minute")),
                          void 0 !== J &&
                            ((a[0] = J[0].toString()),
                            (a[1] = J[1].toString()),
                            a[0].length < 2 && (a[0] = "0".concat(a[0]))),
                          (c = [
                            s,
                            d,
                            "1" == v && 0 < a.length
                              ? ("12" <= a[0] && "12" != a[0] && (a[0] -= "12"),
                                (a[0] = a[0].toString()),
                                (a[0] =
                                  a[0].length < 2 ? "0".concat(a[0]) : a[0]),
                                "1" == OTD_eddResultJson.show_edd_between_dates
                                  ? ((f = (n =
                                      "" != OTD_eddResultJson.dates_name
                                        ? OTD_eddResultJson.dates_name.split(
                                            ",",
                                          )
                                        : [
                                            "Sunday",
                                            "Monday",
                                            "Tuesday",
                                            "Wednesday",
                                            "Thursday",
                                            "Friday",
                                            "Saturday",
                                          ])[new Date(j).getDay()]),
                                    (_ = OTD_minDate.split("-")),
                                    (m =
                                      n[
                                        (l = addDays(
                                          (_ = new Date(_[0], _[1] - 1, _[2])),
                                          OTD_eddResultJson.max_delivery_days,
                                        )).getDay()
                                      ]),
                                    (u = (l = dateObjToString(l)).split("-")),
                                    f +
                                      ", " +
                                      w[2] +
                                      "-" +
                                      OTD_daysArr[w[1] - 1] +
                                      "-" +
                                      w[0] +
                                      " - " +
                                      m +
                                      ", " +
                                      u[2] +
                                      "-" +
                                      OTD_daysArr[u[1] - 1] +
                                      "-" +
                                      u[0])
                                  : "12" ==
                                      OTD_eddResultJson.time_display_format
                                    ? Q +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " - " +
                                      convert_time_24to12(deliveryTimeArr_24[0])
                                    : weekDay_24 +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " - " +
                                      finalStartDeliveryTime_24 +
                                      " - " +
                                      finalEndDeliveryTime_24)
                              : ((o = ""),
                                void 0 !== J &&
                                  (12 <= J[0] && 12 < J[0] && (J[0] -= 12),
                                  (J[0] = J[0].toString()),
                                  (J[0] =
                                    J[0].length < 2 ? "0".concat(J[0]) : J[0]),
                                  (o = " - " + J[0] + ":" + J[1])),
                                "1" == OTD_eddResultJson.show_edd_between_dates
                                  ? ((f = (n =
                                      "" != OTD_eddResultJson.dates_name
                                        ? OTD_eddResultJson.dates_name.split(
                                            ",",
                                          )
                                        : [
                                            "Sunday",
                                            "Monday",
                                            "Tuesday",
                                            "Wednesday",
                                            "Thursday",
                                            "Friday",
                                            "Saturday",
                                          ])[new Date(j).getDay()]),
                                    (_ = OTD_minDate.split("-")),
                                    (m =
                                      n[
                                        (l = addDays(
                                          (_ = new Date(_[0], _[1] - 1, _[2])),
                                          OTD_eddResultJson.max_delivery_days,
                                        )).getDay()
                                      ]),
                                    (u = (l = dateObjToString(l)).split("-")),
                                    f +
                                      ", " +
                                      w[2] +
                                      " " +
                                      OTD_daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " - " +
                                      m +
                                      ", " +
                                      u[2] +
                                      " " +
                                      OTD_daysArr[u[1] - 1] +
                                      " " +
                                      u[0])
                                  : Q +
                                    ", " +
                                    w[2] +
                                    " " +
                                    OTD_daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    o),
                          ]),
                          x &&
                            "" != x &&
                            (p = (D = x.includes(k[0])
                              ? x.replaceAll(k[0], c[0])
                              : x).includes(k[1])
                              ? D.replaceAll(k[1], c[1])
                              : D).includes(k[2]) &&
                            (p = p.replaceAll(k[2], c[2])),
                          "0" == OTD_eddResultJson.edd_display_position
                            ? (1 < h.length &&
                              "add-to-cart-form" ==
                                jQueryOTD(".form").attr("data-type")
                                ? jQueryOTD(".form")
                                : h
                              ).after('<div id="main_content">' + p + "</div>")
                            : "1" == OTD_eddResultJson.edd_display_position &&
                              (1 < h.length &&
                              "add-to-cart-form" ==
                                jQueryOTD(".form").attr("data-type")
                                ? jQueryOTD(".form")
                                : h
                              ).before(
                                '<div id="main_content">' + p + "</div>",
                              ),
                          OTD_eddResultJson.edd_datetime_margin &&
                            ((y = OTD_eddResultJson.edd_datetime_margin),
                            jQueryOTD("#main_content").find(
                              ".edd_dateTime_class",
                            ) &&
                              jQueryOTD("#main_content")
                                .find(".edd_dateTime_class")
                                .css({
                                  margin:
                                    y.edd_datetime_margin_top +
                                    "px " +
                                    y.edd_datetime_margin_right +
                                    "px " +
                                    y.edd_datetime_margin_bottom +
                                    "px " +
                                    y.edd_datetime_margin_left +
                                    "px",
                                })),
                          OTD_eddResultJson.edd_timer_margin &&
                            ((T = OTD_eddResultJson.edd_timer_margin),
                            jQueryOTD("#main_content").find(
                              ".edd_timerDayHour_class",
                            ) &&
                              jQueryOTD("#main_content")
                                .find(".edd_timerDayHour_class")
                                .css({
                                  margin:
                                    T.edd_timer_margin_top +
                                    "px " +
                                    T.edd_timer_margin_right +
                                    "px " +
                                    T.edd_timer_margin_bottom +
                                    "px " +
                                    T.edd_timer_margin_left +
                                    "px",
                                })),
                          OTD_eddResultJson.edd_timer_appearance &&
                            ((O = OTD_eddResultJson.edd_timer_appearance),
                            jQueryOTD(".timer_digit").css({
                              "background-color": O.edd_timer_digit_bg_color,
                              color: O.edd_timer_digit_color,
                              "font-size": O.edd_timer_font_size + "px",
                            }),
                            jQueryOTD(".timer_label").css({
                              "font-size": O.edd_timer_label_font_size + "px",
                              "font-weight": O.edd_timer_label_font_weight,
                              color: O.edd_timer_units_label_color,
                            }),
                            jQueryOTD(".edd_timer_separator").css({
                              "font-size": O.edd_timer_font_size + "px",
                              color: O.edd_timer_separator_color,
                            }))),
                      -1 === Math.sign(t) &&
                        (estimated_delivery_date(), t < 0 && clearInterval(V)),
                      clearInterval(V));
                  }, 1e3)))
                : "2" == v &&
                  ((z = x),
                  (W =
                    void 0 !== (H = null != m ? m[0] : H)
                      ? Q +
                        ", " +
                        w[2] +
                        " " +
                        OTD_daysArr[w[1] - 1] +
                        " " +
                        w[0] +
                        " - " +
                        H
                      : ((W = OTD_eddResultJson.delivery_time),
                        Q +
                          ", " +
                          w[2] +
                          " " +
                          OTD_daysArr[w[1] - 1] +
                          " " +
                          w[0] +
                          " - " +
                          W[0])),
                  (z = z.replaceAll("{{date_time}}", W)),
                  "0" == OTD_eddResultJson.edd_display_position
                    ? (1 < h.length &&
                      "add-to-cart-form" == jQueryOTD(".form").attr("data-type")
                        ? jQueryOTD(".form")
                        : h
                      ).after('<div id="main_content">' + z + "</div>")
                    : "1" == OTD_eddResultJson.edd_display_position &&
                      (1 < h.length &&
                      "add-to-cart-form" == jQueryOTD(".form").attr("data-type")
                        ? jQueryOTD(".form")
                        : h
                      ).before('<div id="main_content">' + z + "</div>"),
                  jQueryOTD("#main_content")
                    .find(".edd_timerDayHour_class")
                    .hide(),
                  jQueryOTD("#main_content").find(".edd_dayHour_class").hide(),
                  jQueryOTD("#main_content")
                    .find(".edd_dateTime_class")
                    .addClass("edd_date_time_style"),
                  OTD_eddResultJson.edd_datetime_margin &&
                    ((z = OTD_eddResultJson.edd_datetime_margin),
                    jQueryOTD("#main_content").find(".edd_dateTime_class") &&
                      jQueryOTD("#main_content")
                        .find(".edd_dateTime_class")
                        .css({
                          "margin-bottom": z.edd_datetime_margin_bottom + "px",
                          "margin-left": z.edd_datetime_margin_left + "px",
                          "margin-right": z.edd_datetime_margin_right + "px",
                          "margin-top": z.edd_datetime_margin_top + "px",
                        }))))));
      },
    }));
}
function date_change_onTimeDel_function_edd(e, t, a, r) {
  var d = r.hide_slots_settings;
  (jQueryOTD(".iweb-dt-deliveryTime").addClass(
    "iweb_order_delivery_advance_loader loader",
  ),
    jQueryOTD(".iweb-dt-deliveryTime").attr("disabled", "true"),
    jQueryOTD(".iweb-dt-deliveryRequired").hide(),
    jQueryOTD(".iweb-dt-deliveryTime").removeClass("iweb-dt-isRequired"),
    jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
      "iweb-dt-isRequired",
    ));
  var i = new Date(e),
    s = ("0" + i.getDate()).slice(-2),
    o = ("0" + (i.getMonth() + 1)).slice(-2),
    n = i.getFullYear(),
    e = s + "-" + o + "-" + n,
    _ = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ][i.getDay()],
    l = dateFormatConvert("dd-mm-yy", t, "-", a, e),
    m = find_separator_date(r.date_format),
    u = dateFormatConvert(r.date_format, t, m, a, r.min_date),
    c = r.today_date;
  jQueryOTD(".iweb-dt-deliveryTime").children("option").remove();
  var D = '<option value="">' + r.select_time_text + "</option>",
    p = '<option value="">' + r.select_time_text + "</option>",
    y = r.cutoff_time,
    T = (y = y.split("."))[0],
    i = y[1],
    m = (c = c.split("-"))[0],
    y = c[1],
    c = c[2],
    O = dateFormatConvert("dd-mm-yy", t, "-", a, (O = c + "-" + y + "-" + m)),
    f = r.hr_24,
    h = r.min,
    v = r.padding_time_status,
    g = r.padding_time_min_days_status,
    b = r.padding_hour_24,
    j = r.padding_minute,
    w = r.min_day_value,
    m = !1;
  if (((tempObj = {}), void 0 === e)) console.log("Something wrong");
  else if (void 0 !== e && "0" == r.timer_status_format) {
    for (
      var Q = r.delivery_time.time,
        x = [],
        A = [],
        I = [],
        S = [],
        J = [],
        k = 0;
      k < Q.length;
      k++
    )
      ((x[k] =
        '<option value="' +
        r.delivery_time.time_24[k] +
        '">' +
        r.delivery_time.time_24[k] +
        "</option>"),
        (A[k] = r.delivery_time.time_24[k]),
        (I[k] = r.delivery_time.time[k]));
    (1 == r.cutoff_time_status && l == O) ||
    (1 == r.cutoff_time_status &&
      1 == r.cutoff_time_min_day &&
      l == u &&
      0 != r.min_day_value)
      ? parseInt(T) < parseInt(f) ||
        (parseInt(T) == parseInt(f) && parseInt(i) < parseInt(h))
        ? (m = !0)
        : jQueryOTD.each(Q, function (e, t) {
            var a, r, i;
            (l == O || l == u
              ? ((start_time = t.split(":")),
                (r = 60 * start_time[0]),
                (i = start_time[1]),
                (a = parseInt(r) + parseInt(i)),
                (t = 60 * b + j),
                1 == d
                  ? ((r = start_time[0]),
                    (i = start_time[1]),
                    1 == v && 0 == g && 0 != w
                      ? (f < r || (f == r && h < i)) &&
                        ((D += x[e]), (S[e] = A[e]), (J[e] = I[e]))
                      : 1 == v &&
                        t <= a &&
                        ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])),
                    0 == v &&
                      (f < r || (f == r && h < i)) &&
                      ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])))
                  : ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])))
              : ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])),
              D.length);
          })
      : jQueryOTD.each(Q, function (e, t) {
          var a, r, i;
          (l == O || l == u
            ? ((start_time = t.split(":")),
              (r = 60 * start_time[0]),
              (i = start_time[1]),
              (a = parseInt(r) + parseInt(i)),
              (t = 60 * b + j),
              1 == d
                ? ((r = start_time[0]),
                  (i = start_time[1]),
                  1 == v && 0 == g && 0 != w
                    ? (f < r || (f == r && h < i)) &&
                      ((D += x[e]), (S[e] = A[e]), (J[e] = I[e]))
                    : 1 == v &&
                      t <= a &&
                      ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])),
                  0 == v &&
                    (f < r || (f == r && h < i)) &&
                    ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])))
                : ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])))
            : ((D += x[e]), (S[e] = A[e]), (J[e] = I[e])),
            D.length);
        });
  } else if (void 0 !== e && "1" == r.timer_status_format) {
    ((1 == r.cutoff_time_status && l == O) ||
      (1 == r.cutoff_time_status &&
        1 == r.cutoff_time_min_day &&
        l == u &&
        0 != r.min_day_value)) &&
      ((1 == r.cutoff_time_status && parseInt(T) < parseInt(f)) ||
        (1 == r.cutoff_time_status &&
          parseInt(T) == parseInt(f) &&
          parseInt(i) < parseInt(h))) &&
      (m = !0);
    var R = [],
      F = "",
      L = 0;
    0 != r.order_data &&
      jQueryOTD.each(r.order_data, function (e, t) {
        var a = t.delivery_date,
          r = (a = a.split("-"))[0],
          i = a[1],
          a = a[2];
        r == n &&
          i == o &&
          a == s &&
          "" != t.delivery_time &&
          (F.replace(/\s/g, "") !== t.delivery_time.replace(/\s/g, "")
            ? ((F = t.delivery_time),
              ((a = []).count = 1),
              "12" == t.time_format_hour
                ? find_separator_time(t.delivery_time, "12")
                : find_separator_time(t.delivery_time, "24"),
              (a.time_slot = t.delivery_time),
              void 0 !== a.time_slot &&
                ((a.start_time = a.time_slot.split("-")[0]),
                (a.end_time = a.time_slot.split("-")[1]),
                R.push(a),
                L++))
            : 0 != L && (R[L - 1].count = R[L - 1].count + 1));
      });
    for (
      var C = r.delivery_time,
        N = [],
        M = [],
        q = [],
        P = [],
        E = [],
        V = [],
        $ = [],
        k = 0;
      k < C[_].start_time.length;
      k++
    ) {
      var H = C[_].start_time[k] + "-" + C[_].end_time[k],
        W = C[_].start_time[k] + "-" + C[_].end_time[k],
        z = { pre: C[_].pre_message[k], post: C[_].post_message[k] },
        U = "" != C[_].limit[k] ? parseInt(C[_].limit[k]) : 0,
        B = "" != C[_].totalorder[k] ? parseInt(C[_].totalorder[k]) : 0;
      0 < R.length
        ? jQueryOTD.each(R, function (e, t) {
            1 == U && 0 < B
              ? ((H = H.replace(/\s/g, "")),
                (W = W.replace(/\s/g, "")),
                (t.time_slot = t.time_slot.replace(/\s/g, "")),
                0 != C[_].start_time[k].localeCompare(t.start_time) ||
                0 != C[_].end_time[k].localeCompare(t.end_time) ||
                B > parseInt(t.count)
                  ? -1 == N.indexOf(H) && (N.push(H), M.push(W), q.push(z))
                  : -1 == V.indexOf(H) && (V.push(H), $.push(z)))
              : 0 == U &&
                -1 == N.indexOf(H) &&
                (N.push(H), M.push(W), q.push(z));
          })
        : ((1 == U && 0 < B) || 0 == U) &&
          -1 == N.indexOf(H) &&
          (N.push(H), M.push(W), q.push(z));
    }
    (l != O && l != u) ||
      jQueryOTD.each(N, function (e, t) {
        s =
          "12" == t.time_display_format
            ? find_separator_time(t, "12")
            : find_separator_time(t, "24");
        var a = t.split(s)[0],
          r = (a = a.split(":"))[0],
          i = a[1],
          a = (a = t.split(s)[0]).split(":"),
          s = 60 * parseInt(a[0]) + parseInt(a[1]),
          a = 60 * parseInt(b) + parseInt(j);
        1 == d &&
          (1 == v && 0 == g && 0 != w
            ? (r <= f || f == r) &&
              i < h &&
              -1 == V.indexOf(t) &&
              (V.push(t), $.push(q[e]))
            : 1 == v &&
              s <= a &&
              ((l != O && l != u) ||
                (-1 == V.indexOf(t) && (V.push(t), $.push(q[e]))),
              l == u &&
                1 == g &&
                0 != w &&
                -1 == V.indexOf(t) &&
                (V.push(t), $.push(q[e]))),
          0 == v &&
            (r <= f || f == r) &&
            i < h &&
            -1 == V.indexOf(t) &&
            (V.push(t), $.push(q[e])));
      });
    m = !1;
    ((1 == r.cutoff_time_status && l == O) ||
      (1 == r.cutoff_time_status &&
        1 == r.cutoff_time_min_day &&
        l == u &&
        0 != r.min_day_value)) &&
      (parseInt(T) < parseInt(f) ||
        (parseInt(T) == parseInt(f) && parseInt(i) < parseInt(h))) &&
      (m = !0);
    var Y = [],
      G = [];
    m
      ? 0
      : (0 < V.length
          ? jQuery.grep(N, function (e, t) {
              -1 == jQuery.inArray(e, V) &&
                (P.push(e), E.push(M[t]), Y.push(q[t].pre), G.push(q[t].post));
            })
          : jQueryOTD.each(N, function (e, t) {
              (P.push(t), E.push(M[e]), Y.push(q[e].pre), G.push(q[e].post));
            }),
        P.sort(),
        (J = P));
  } else
    void 0 !== e && "2" == r.timer_status_format
      ? (1 == r.cutoff_time_status && l == O) ||
        (1 == r.cutoff_time_status &&
          1 == r.cutoff_time_min_day &&
          l == u &&
          0 != r.min_day_value)
        ? (1 == r.cutoff_time_status && parseInt(T) < parseInt(f)) ||
          (1 == r.cutoff_time_status &&
            parseInt(T) == parseInt(f) &&
            (parseInt(i), parseInt(h)))
        : ((e = r.delivery_time), (tempObj = e))
      : ((1 == r.cutoff_time_status && l == O) ||
          (1 == r.cutoff_time_status &&
            1 == r.cutoff_time_min_day &&
            l == u &&
            0 != r.min_day_value)) &&
        ((1 == r.cutoff_time_status && parseInt(T) < parseInt(f)) ||
          (1 == r.cutoff_time_status &&
            parseInt(T) == parseInt(f) &&
            (parseInt(i), parseInt(h))));
  return (
    "2" != r.timer_status_format &&
      void 0 !== J &&
      ((tempObj_12 = {}),
      (tempObj_24 = {}),
      Object.keys(J).forEach((e, t) => {
        (null != S && S[e] && (tempObj_12[t] = S[e]),
          J[e] && (tempObj_24[t] = J[e]));
      }),
      (tempObj = { tempObj_12: tempObj_12, tempObj_24: tempObj_24 })),
    tempObj
  );
}
function addOneDay(e, t, a, r) {
  return (e =
    "object" ==
    typeof (e = recursiveOnDisableDays(
      (e = recursiveOnDisableDates((e = addDays(e, t)), a)),
      r,
    ))
      ? formatDate(e)
      : e);
}
function formatDate(e) {
  var t = new Date(e),
    a = "" + (t.getMonth() + 1),
    e = "" + t.getDate();
  return [
    t.getFullYear(),
    (a = a.length < 2 ? "0" + a : a),
    (e = e.length < 2 ? "0" + e : e),
  ].join("-");
}
function edd_orderLimit(i, e, t, s) {
  var a = e,
    d = [],
    r = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ],
    e = new Date(i).getDay(),
    o = a[(r = daysArray[e])].start_time,
    n = a[r].end_time,
    _ = a[r].to_message,
    l = a[r].limit,
    m = a[r].totalorder,
    u = o.indexOf(t[0]),
    c = [],
    D = [],
    p = [],
    y = [],
    T = [];
  (jQueryOTD.each(o, function (e, t) {
    u <= e &&
      (c.push(o[e]), D.push(n[e]), p.push(_[e]), y.push(l[e]), T.push(m[e]));
  }),
    0 < t.length &&
      jQueryOTD.each(t, function (e, t) {
        e = {
          startTime: c[e],
          endTime: D[e],
          toMessage: p[e],
          limitStatus: y[e],
          totalOrders: T[e],
          createdDeliveryTime: c[e] + "-" + D[e],
        };
        d.push(e);
      }));
  for (var O = d.length - 1; 0 <= O; O--)
    "1" == d[O].limitStatus && "0" == d[O].totalOrders && d.splice(O, 1);
  var f = [];
  if (
    (jQueryOTD.each(d, function (e, t) {
      for (var a = s.length - 1; 0 <= a; a--) {
        var r = s[a];
        d[e].createdDeliveryTime == r.delivery_time &&
          i == r.delivery_date &&
          "" !== r.total_orders &&
          "" !== d[e].totalOrders &&
          parseInt(r.total_orders) >= parseInt(d[e].totalOrders) &&
          f.push(e);
      }
    }),
    0 < f.length)
  )
    for (O = f.length - 1; 0 <= O; O--) d.splice(O, 1);
  var h = [],
    v = [];
  return (
    jQueryOTD.each(d, function (e, t) {
      (h.push(d[e].startTime), v.push(d[e].endTime));
    }),
    { startTime: h, endTime: v }
  );
}
function addDays(e, t) {
  e = new Date(e);
  return (e.setDate(e.getDate() + parseInt(t)), e);
}
function recursiveOnDisableDates(e, t) {
  if (t.includes(e)) {
    var a = addDays(e, 1),
      r = a.getDate();
    r = (r = r.toString()).length < 2 ? "0".concat(r) : r;
    var i = (i = (a.getMonth() + 1).toString()).length < 2 ? "0".concat(i) : i;
    return recursiveOnDisableDates(
      (e = a.getFullYear() + "-" + i + "-" + r),
      t,
    );
  }
  return e;
}
function recursiveOnDisableDays(e, t, a) {
  var r = e,
    i = t,
    e = a,
    a = new Date(r).getDay();
  if (i.includes(a.toString())) {
    ((i = (i = (r = addDays(r, 1)).getDate()).length < 2 ? "0".concat(i) : i),
      (a = (a = (r.getMonth() + 1).toString()).length < 2 ? "0".concat(a) : a));
    return recursiveOnDisableDays(
      recursiveOnDisableDates(r.getFullYear() + "-" + a + "-" + i, e),
      t,
      e,
    );
  }
  return r;
}
function recursiveOnDeliveryTime_cutoff_zero(e, t, a) {
  var r = [];
  return (r = "cutoff" == a ? (t[0] > e ? "" : t) : r);
}
function recursiveOnDeliveryTime_cutoff_one(e, t, a) {
  var r = [];
  return (r = "cutoff" == a ? (e < t[0] ? "" : t) : r);
}
function dateObjToString(e) {
  var t = e.getDate(),
    a = e.getMonth() + 1,
    t = t.toString(),
    a = a.toString();
  return (
    (t = t.length < 2 ? "0".concat(t) : t),
    (a = a.length < 2 ? "0".concat(a) : a),
    e.getFullYear() + "-" + a + "-" + t
  );
}
function dateObjToTimeString(e) {
  var t = e.getHours(),
    e = e.getMinutes();
  return (
    (t = (t = t.toString()).length < 2 ? "0".concat(t) : t) +
    ":" +
    (e = (e = e.toString()).length < 2 ? "0".concat(e) : e)
  );
}
function change_time_12to24(e, t) {
  var a = (e = e.replace(/\s/g, "")).split(t),
    r = a[0],
    i = a[1];
  if (
    ((r = r.replace(/\s/g, "")),
    (i = i.replace(/\s/g, "")),
    1 < r.length &&
      "" != r &&
      "" != i &&
      (null != r.match("(AM)") || null != r.match("(PM)")))
  ) {
    var s = Number(r.match(/^(\d+)/)[1]),
      d = Number(r.match(/:(\d+)/)[1]);
    null != r.match("(AM)")
      ? "AM" == r.match("(AM)")[1].toUpperCase() && 12 == s && (s -= 12)
      : null != r.match("(PM)") &&
        "PM" == r.match("(PM)")[1].toUpperCase() &&
        s < 12 &&
        (s += 12);
    ((e = s.toString()),
      (a = d.toString()),
      (r = (e = s < 10 ? "0" + e : e) + ":" + (a = d < 10 ? "0" + a : a)),
      (i = i.replace(/\s/g, "")),
      (s = Number(i.match(/^(\d+)/)[1])),
      (d = Number(i.match(/:(\d+)/)[1])));
    null != i.match("(AM)")
      ? "AM" == i.match("(AM)")[1].toUpperCase() && 12 == s && (s -= 12)
      : null != i.match("(PM)") &&
        "PM" == i.match("(PM)")[1].toUpperCase() &&
        s < 12 &&
        (s += 12);
    ((e = s.toString()), (a = d.toString()));
    return (
      r +
      t +
      (i = (e = s < 10 ? "0" + e : e) + ":" + (a = d < 10 ? "0" + a : a))
    );
  }
}
function find_separator_time(e, t) {
  var a;
  return (
    (e = e.replace(/\s/g, "")),
    (t = "24" == t ? e.length - (a = 5) : e.length - (a = 7)),
    e.substring(a, t)
  );
}
function convert_time_24to12(e, t = 0) {
  var a = e.length - 5,
    r = e.substring(5, a),
    i = e.split(r),
    s = i[0],
    a = i[1],
    e = +s.substr(0, 2),
    i = e < 12 ? " AM" : " PM",
    s = ("0" + (e % 12 || 12)).slice(-2) + s.substr(2, 3) + i,
    e = +a.substr(0, 2),
    i = e < 12 ? " AM" : " PM",
    i =
      s +
      " " +
      r +
      " " +
      (a = ("0" + (e % 12 || 12)).slice(-2) + a.substr(2, 3) + i);
  return (i = t ? s.replace(" ", "") + "" + r + a.replace(" ", "") : i);
}
function find_separator_date(e) {
  var t = e.substring(2, 3);
  return "/" == t ||
    "-" == t ||
    "." == t ||
    "/" == (t = e.substring(4, 5)) ||
    "-" == t ||
    "." == t
    ? t
    : void console.log("something wrong in date separator find");
}
function check_validation(e, t, a, r, i) {
  (jQueryOTD(".iweb-dt-deliveryRequired").hide(),
    "NULL" != i.timer_status_format
      ? jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()
        ? 0 < jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").length &&
          !jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val()
          ? "vaporetto-pizza.myshopify.com" == OTD_shopName
            ? (jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
                "iweb-dt-isRequired",
              ),
              jQueryOTD(".iweb-dt-deliveryRequired").hide(),
              t.unbind("submit"))
            : ("araya-chocolate.myshopify.com" == OTD_shopName
                ? jQueryOTD("html, body").animate(
                    {
                      scrollTop:
                        jQueryOTD(".iw-order-delivery-dt-calendar").offset()
                          .top - 500,
                    },
                    1e3,
                  )
                : document
                    .querySelectorAll(".iw-order-delivery-dt-calendar")
                    .forEach((e) =>
                      e.scrollIntoView({ behavior: "smooth", block: "center" }),
                    ),
              jQueryOTD(".iweb-dt-deliveryRequired").html(r).show(),
              jQueryOTD(".iweb-dt-deliveryTime").addClass("iweb-dt-isRequired"),
              setTimeout(function () {
                t.find("[name='checkout']").removeClass("btn--loading");
              }, 0),
              e.preventDefault(),
              e.stopImmediatePropagation())
          : ("undefined" != typeof BOLD &&
              void 0 !== BOLD.recurring_orders &&
              void 0 !== BOLD.recurring_orders.app &&
              void 0 !== BOLD.recurring_orders.app.cartWidget &&
              (BOLD.recurring_orders.app.cartWidget.checkoutEnabled = !0),
            jQueryOTD(".iweb-dt-deliveryTime").removeClass(
              "iweb-dt-isRequired",
            ),
            jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
              "iweb-dt-isRequired",
            ),
            jQueryOTD(".iweb-dt-deliveryRequired").hide(),
            t.unbind("submit"),
            t.find("[name='checkout']").length
              ? (t.find("[name='checkout']").unbind("click"),
                t.find("[name='checkout']").click())
              : "appi-earth.myshopify.com" != OTD_shopName && t.submit(),
            "liliyum-patisserie-cafe.myshopify.com" == OTD_shopName &&
              (e.preventDefault(),
              e.stopImmediatePropagation(),
              window.stop(),
              (window.location.href = "/checkout")))
        : ("araya-chocolate.myshopify.com" == OTD_shopName
            ? jQueryOTD("html, body").animate(
                {
                  scrollTop:
                    jQueryOTD(".iw-order-delivery-dt-calendar").offset().top -
                    500,
                },
                1e3,
              )
            : document
                .querySelectorAll(".iw-order-delivery-dt-calendar")
                .forEach((e) =>
                  e.scrollIntoView({ behavior: "smooth", block: "center" }),
                ),
          jQueryOTD(".iweb-dt-deliveryRequired")
            .html(a)
            .attr("style", "display:block"),
          jQueryOTD(".iw-order-delivery-dt-calendar").addClass(
            "iweb-dt-isRequired",
          ),
          setTimeout(function () {
            t.find("[name='checkout']").removeClass("btn--loading");
          }, 0),
          e.preventDefault(),
          e.stopImmediatePropagation())
      : jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()
        ? ("undefined" != typeof BOLD &&
            void 0 !== BOLD.recurring_orders &&
            void 0 !== BOLD.recurring_orders.app &&
            void 0 !== BOLD.recurring_orders.app.cartWidget &&
            (BOLD.recurring_orders.app.cartWidget.checkoutEnabled = !0),
          jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
            "iweb-dt-isRequired",
          ),
          jQueryOTD(".iweb-dt-deliveryRequired").hide(),
          t.unbind("submit"),
          jQueryOTD('a[href="/checkout"]').length &&
            jQueryOTD('a[href="/checkout"]').unbind("click"),
          t.find("[name='checkout']").length
            ? (t.find("[name='checkout']").unbind("click"),
              t.find("[name='checkout']").click())
            : t.submit())
        : ("araya-chocolate.myshopify.com" == OTD_shopName
            ? jQueryOTD("html, body").animate(
                {
                  scrollTop:
                    jQueryOTD(".iw-order-delivery-dt-calendar").offset().top -
                    500,
                },
                1e3,
              )
            : document
                .querySelectorAll(".iw-order-delivery-dt-calendar")
                .forEach((e) =>
                  e.scrollIntoView({ behavior: "smooth", block: "center" }),
                ),
          jQueryOTD(".iweb-dt-deliveryRequired").html(a).show(),
          jQueryOTD(".iw-order-delivery-dt-calendar").addClass(
            "iweb-dt-isRequired",
          ),
          setTimeout(function () {
            t.find("[name='checkout']").removeClass("btn--loading");
          }, 0),
          e.preventDefault(),
          e.stopImmediatePropagation()));
}
function dateFormatConvert(e, t, a, r, i, s) {
  var d = e.toLowerCase().split(a),
    o = t.toLowerCase().split(r);
  if ("loop" == s) {
    var n = [];
    return (
      jQueryOTD.each(i, function (e, t) {
        t = t.split(a);
        ((t[d[0]] = t[0]),
          (t[d[1]] = t[1]),
          (t[d[2]] = t[2]),
          n.push(t[o[0]] + r + t[o[1]] + r + t[o[2]]));
      }),
      n
    );
  }
  ((n = ""), (i = i.split(a)));
  return (
    (i[d[0]] = i[0]),
    (i[d[1]] = i[1]),
    (i[d[2]] = i[2]),
    (n = i[o[0]] + r + i[o[1]] + r + i[o[2]])
  );
}
function oddt_invalid_days(e) {
  var t = e && e.split(",");
  if (t.length) for (var a = 0; a < t.length; a++) t[a] = parseInt(t[a]);
  else t = [];
  return t;
}
function oddt_disable_dates(e) {
  var t = !1;
  return (t = e ? e.split(",") : t);
}
function oddt_day_text_value(e) {
  e = parseDate(e);
  return [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ][new Date(e).getDay()];
}
function oddt_month_text_value(e) {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ][new Date(e).getMonth()];
}
function parseDate(e) {
  var t = Date.parse(e);
  return isNaN(t)
    ? Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "))
    : t;
}
function oddt_cutOffTimeDate(e, t, a, r) {
  var i = 0,
    s = t,
    d = e.currentmonthday,
    o = r,
    n = e.currentHr,
    _ = e.cutoff_time_status,
    r = e.cutoff_hour_minute;
  a = parseDate(a);
  ((e = new Date(a).getDate()), (a = oddt_month_text_value(a)));
  return (i =
    0 == _ ||
    t != s ||
    parseInt(d) != parseInt(e) ||
    o != a ||
    parseFloat(n) <= parseFloat(r)
      ? 1
      : i);
}
function oddt_get_time_slots(e, t, a, r) {
  var i = e,
    e = i.time_format;
  return 0 == e
    ? oddt_time_dropdown_format_zero(i, t, a, r)
    : 1 == e
      ? oddt_time_dropdown_format_three(i, t, a, r)
      : 2 == e
        ? oddt_time_dropdown_format_one(i, t, a, r)
        : void 0;
}
function hide_slots_settings(e, t) {
  return 1 == e.hide_slots_settings ||
    1 == e.padding_time_status ||
    (1 == e.cutoff_time_status && e.currentHr >= e.cutoff_hour_minute)
    ? t
    : 0;
}
function shipping_calender_show(e, t, a) {
  if (0 < e && 0 < t && e <= t)
    return (
      jQueryOTD(".appsonrent-dds-local-delivery-preloader").hide(),
      jQueryOTD(".main_loader").after(
        '<div class="appsonrent-dds-main"><p class="appsonrent-dds-deliveryRequired" style="display:block">Delivery date selection is not available for cart.</p></div>',
      ),
      !0
    );
  (auto_minday_calculation(
    (oddShippingCalander = OTD_resultJson).auto_date,
    OTD_resultJson,
    oddt_invalid_days(OTD_resultJson.invalid_day),
    OTD_resultJson.date_format,
    oddt_disable_dates(OTD_resultJson.extra_no_available),
    "otd_shipping",
  ),
    shipping_show(OTD_resultJson, a));
}
function convertFixDate(t, a) {
  if (t) {
    let e = t;
    var r = -1 < t.indexOf("/") ? t.split("/") : t.split("-");
    return (
      "dd/mm/yy" === a || "dd-mm-yy" === a
        ? (e = `${r[1]}/${r[0]}/${r[2]}`)
        : "dd/yy/mm" === a || "dd-yy-mm" === a
          ? (e = `${r[2]}/${r[0]}/${r[1]}`)
          : "mm/yy/dd" === a || "mm-yy-dd" === a
            ? (e = `${r[0]}/${r[2]}/${r[1]}`)
            : "yy/dd/mm" === a || "yy-dd-mm" === a
              ? (e = `${r[2]}/${r[1]}/${r[0]}`)
              : "mm/dd/yy" === a || "mm-dd-yy" === a
                ? (e = `${r[0]}/${r[1]}/${r[2]}`)
                : ("yy-mm-dd" !== a && "yy/mm/dd" !== a) ||
                  (e = `${r[1]}/${r[2]}/${r[0]}`),
      new Date(e)
    );
  }
  return new Date(t);
}
function date_change_onTimeDel_function(o, e, t) {
  var n = o.min_date,
    a = o.date_format,
    i = !0,
    _ = o.hide_slots_settings;
  (jQueryOTD(".iweb-dt-deliveryTime").addClass(
    "iweb_order_delivery_advance_loader loader",
  ),
    jQueryOTD(".iweb-dt-deliveryTime").attr("disabled", "true"),
    jQueryOTD(".iweb-dt-deliveryRequired").hide(),
    jQueryOTD(".iweb-dt-deliveryTime").removeClass("iweb-dt-isRequired"),
    jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
      "iweb-dt-isRequired",
    ),
    (e = convertFixDate(e, "mm-dd-yy")));
  var r = new Date(e),
    d = ("0" + r.getDate()).slice(-2),
    l = ("0" + (r.getMonth() + 1)).slice(-2),
    m = r.getFullYear(),
    e = d + "-" + l + "-" + m,
    s = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ][r.getDay()],
    u = find_separator_date(a),
    c = dateFormatConvert("dd-mm-yy", a, "-", u, e),
    D = formatDate(o.today_date.date),
    p = r.getDay();
  jQueryOTD(".iweb-dt-deliveryTime").children("option").remove();
  var y = '<option value="">' + o.select_time_text + "</option>",
    T = '<option value="">' + o.select_time_text + "</option>",
    O = o.cutoff_hour,
    f = o.cutoff_minute,
    h = (D = D.split("-"))[0],
    r = D[1],
    D = D[2],
    v = dateFormatConvert("dd-mm-yy", a, "-", u, (v = D + "-" + r + "-" + h)),
    g = (o.hr, o.hr_24),
    b = o.min,
    j = o.padding_time_status,
    w = o.padding_time_min_status,
    Q = o.padding_hour_24,
    x = o.padding_minute,
    A = o.min_day_value,
    h = !1;
  if (void 0 === e) console.log("Something wrong");
  else if (void 0 !== e && "0" == o.timer_status_format) {
    for (
      var I = o.delivery_time.time.split(","), S = [], J = 0;
      J < I.length;
      J++
    )
      S[J] =
        '<option value="' +
        o.delivery_time.time_24[J] +
        '">' +
        o.delivery_time.time_24[J] +
        "</option>";
    (1 == o.cutoff_time_status && c == v) ||
    (1 == o.cutoff_time_status &&
      1 == o.cutoff_time_min_day &&
      c == n &&
      0 != o.min_day_value)
      ? parseInt(O) < parseInt(g) ||
        (parseInt(O) == parseInt(g) && parseInt(f) < parseInt(b))
        ? (i = !(h = !0))
        : jQueryOTD.each(I, function (e, t) {
            var a, r;
            (c == v || c == n
              ? ((start_time = t.split(":")),
                (a = 60 * start_time[0]),
                (r = start_time[1]),
                (t = parseInt(a) + parseInt(r)),
                1 == _
                  ? ((a = start_time[0]),
                    (r = start_time[1]),
                    1 == j && 0 == w && 0 != A
                      ? (g < a || (g == a && b < r)) && (y += S[e])
                      : 1 == j && 60 * Q + x <= t && (y += S[e]),
                    0 == j &&
                      (g < a || (g == a && b < r)) &&
                      ((i = !0), (y += S[e])))
                  : (y += S[e]))
              : (y += S[e]),
              (i = y.length !== T.length));
          })
      : jQueryOTD.each(I, function (e, t) {
          var a, r;
          (c == v || c == n
            ? ((start_time = t.split(":")),
              (a = 60 * start_time[0]),
              (r = start_time[1]),
              (t = parseInt(a) + parseInt(r)),
              1 == _
                ? ((a = start_time[0]),
                  (r = start_time[1]),
                  1 == j && 0 == w && 0 != A
                    ? (g < a || (g == a && b < r)) && (y += S[e])
                    : 1 == j && 60 * Q + x <= t && (y += S[e]),
                  0 == j &&
                    (g < a || (g == a && b < r)) &&
                    ((i = !0), (y += S[e])))
                : (y += S[e]))
            : (y += S[e]),
            (i = y.length !== T.length));
        });
  } else if (void 0 !== e && "1" == o.timer_status_format) {
    ((1 == o.cutoff_time_status && c == v) ||
      (1 == o.cutoff_time_status &&
        1 == o.cutoff_time_min_day &&
        c == n &&
        0 != o.min_day_value)) &&
      ((1 == o.cutoff_time_status && parseInt(O) < parseInt(g)) ||
        (1 == o.cutoff_time_status &&
          parseInt(O) == parseInt(g) &&
          parseInt(f) < parseInt(b))) &&
      (i = !(h = !0));
    var k = [],
      R = "",
      F = 0;
    0 != o.order_data &&
      jQueryOTD.each(o.order_data, function (e, t) {
        var a,
          r = t.delivery_date,
          i = (r = r.split("-"))[0],
          s = r[1],
          r = r[2];
        i == m &&
          s == l &&
          r == d &&
          "" != t.delivery_time &&
          (R.replace(/\s/g, "") !== t.delivery_time.replace(/\s/g, "")
            ? ((R = t.delivery_time),
              ((r = []).count = 1),
              "12" == t.time_format_hour
                ? ((a = find_separator_time(t.delivery_time, "12")),
                  (r.time_slot = change_time_12to24(t.delivery_time, a)))
                : ((a = find_separator_time(t.delivery_time, "24")),
                  (r.time_slot = t.delivery_time)),
              void 0 !== r.time_slot &&
                ((r.start_time = r.time_slot.split(a)[0]),
                (r.end_time = r.time_slot.split(a)[1]),
                k.push(r),
                F++))
            : 0 != F && (k[F - 1].count = k[F - 1].count + 1));
      });
    for (
      var L = o.time_format_value,
        C = [],
        N = [],
        M = [],
        q = [],
        P = [],
        E = [],
        V = [],
        J = 0;
      J < L[s].start_time.length;
      J++
    ) {
      var $ =
          L[s].start_time[J] +
          " " +
          L[s].to_message[J] +
          " " +
          L[s].end_time[J],
        H = L[s].start_time[J] + "-" + L[s].end_time[J],
        W = "12" == o.time_display_format ? convert_time_24to12(H, 1) : H,
        z = { pre: L[s].pre_message[J], post: L[s].post_message[J] },
        U = "" != L[s].limit[J] ? parseInt(L[s].limit[J]) : 0,
        B = "" != L[s].totalorder[J] ? parseInt(L[s].totalorder[J]) : 0;
      0 < k.length
        ? jQueryOTD.each(k, function (e, t) {
            1 == U && 0 < B
              ? (($ = $.replace(/\s/g, "")),
                (W = W.replace(/\s/g, "")),
                (t.time_slot = t.time_slot.replace(/\s/g, "")),
                0 != L[s].start_time[J].localeCompare(t.start_time) ||
                0 != L[s].end_time[J].localeCompare(t.end_time) ||
                B > parseInt(t.count)
                  ? -1 == C.indexOf($) && (C.push($), N.push(W), M.push(z))
                  : -1 == E.indexOf($) && (E.push($), V.push(z)))
              : 0 == U &&
                -1 == C.indexOf($) &&
                (C.push($), N.push(W), M.push(z));
          })
        : ((1 == U && 0 < B) || 0 == U) &&
          -1 == C.indexOf($) &&
          (C.push($), N.push(W), M.push(z));
    }
    (c != v && c != n) ||
      jQueryOTD.each(C, function (e, t) {
        d =
          "12" == t.time_display_format
            ? find_separator_time(t, "12")
            : find_separator_time(t, "24");
        var a = t.split(d)[0],
          r = t.split(d)[0],
          i = (a = a.split(":"))[0],
          s = a[1],
          a = (a = t.split(d)[0]).split(":"),
          d = 60 * parseInt(a[0]) + parseInt(a[1]),
          a = 60 * parseInt(Q) + parseInt(x);
        1 == _ &&
          (1 == j && 0 == w && 0 != A
            ? (i <= g || g == i) &&
              s < b &&
              -1 == E.indexOf(t) &&
              (E.push(t), V.push(M[e]))
            : 1 == j &&
              d <= a &&
              ((c != v && c != n) ||
                (-1 == E.indexOf(t) && (E.push(t), V.push(M[e]))),
              c == n &&
                1 == w &&
                0 != A &&
                -1 == E.indexOf(t) &&
                (E.push(t), V.push(M[e]))),
          0 == j &&
            (i <= g || g == i) &&
            o.current_time_c > r &&
            -1 == E.indexOf(t) &&
            (E.push(t), V.push(M[e])));
      });
    h = !1;
    ((1 == o.cutoff_time_status && c == v) ||
      (1 == o.cutoff_time_status &&
        1 == o.cutoff_time_min_day &&
        c == n &&
        0 != o.min_day_value)) &&
      (parseInt(O) < parseInt(g) ||
        (parseInt(O) == parseInt(g) && parseInt(f) < parseInt(b))) &&
      (h = !0);
    var Y = [],
      G = [];
    h
      ? (i = !1)
      : (0 < E.length
          ? jQuery.grep(C, function (e, t) {
              -1 == jQuery.inArray(e, E) &&
                (q.push(e), P.push(N[t]), Y.push(M[t].pre), G.push(M[t].post));
            })
          : jQueryOTD.each(C, function (e, t) {
              (q.push(t), P.push(N[e]), Y.push(M[e].pre), G.push(M[e].post));
            }),
        0 < q.length
          ? jQueryOTD.each(q, function (e, t) {
              ((t = "12" == o.time_display_format ? convert_time_24to12(t) : t),
                (y +=
                  '<option value="' +
                  P[e] +
                  '">' +
                  Y[e] +
                  " " +
                  t +
                  " " +
                  G[e] +
                  "</option>"));
            })
          : (i = !1));
  } else if (void 0 !== e && "2" == o.timer_status_format) {
    h = !1;
    if (
      (h =
        ((1 == o.cutoff_time_status && c == v) ||
          (1 == o.cutoff_time_status &&
            1 == o.cutoff_time_min_day &&
            c == n &&
            0 != o.min_day_value)) &&
        (parseInt(O) < parseInt(g) ||
          (parseInt(O) == parseInt(g) && parseInt(f) < parseInt(b)))
          ? !0
          : h)
    )
      i = !1;
    else {
      for (var X = o.delivery_time.split(","), K = "", J = 0; J < X.length; J++)
        K += '<option value="' + X[J] + '">' + X[J] + "</option>";
      i = (y += K).length !== T.length;
    }
  } else
    ((1 == o.cutoff_time_status && c == v) ||
      (1 == o.cutoff_time_status &&
        1 == o.cutoff_time_min_day &&
        c == n &&
        0 != o.min_day_value)) &&
      (i = !(
        (1 == o.cutoff_time_status && parseInt(O) < parseInt(g)) ||
        (1 == o.cutoff_time_status &&
          parseInt(O) == parseInt(g) &&
          parseInt(f) < parseInt(b))
      ));
  if (
    (jQueryOTD(".iweb-dt-deliveryTime").removeAttr("disabled"),
    jQueryOTD(".iweb-dt-deliveryTime").removeClass(
      "iweb_order_delivery_advance_loader loader",
    ),
    "changeDate" == t)
  ) {
    c =
      "dd.mm.yy" == o.convert_date_format
        ? c.replace(/[/,\s]/g, ".").replace(/[-,\s]/g, ".")
        : c;
    (jQueryOTD(".iw-order-delivery-dt-deliveryDayVal").val(
      [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ][p],
    ),
      jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val(c),
      jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val(""),
      0 == i &&
        ((p =
          "undefined" !== (p = o.required_message_order_limit) && "" != p
            ? p
            : "Sorry... You can't order for selected date. Please select other date"),
        jQueryOTD(".iweb-dt-deliveryRequired").html(p).show()),
      jQueryOTD(".iweb-dt-deliveryTime").append(y));
  } else if ("default" == t)
    return (
      (y = '<option value="">' + o.select_time_text + "</option>"),
      jQueryOTD(".iweb-dt-deliveryTime").append(y),
      i
    );
}
function shipping_show(t, e) {
  var a, r, i, s, d, o, n, _, l, m, u, c, D;
  null != t.shipping_product_not_available
    ? (jQueryOTD(".appsonrent-dds-local-delivery-preloader").hide(),
      jQueryOTD(
        'form[action*="/cart"] [name="checkout"],form[action="/cart?locale=en"] [name="checkout"]',
      ).removeAttr("disabled"),
      jQueryOTD(".identixweb-order-delivery").remove(),
      jQueryOTD(".main_loader").after(
        '<div class="appsonrent-dds-main"><p class="appsonrent-dds-deliveryRequired" style="display:block">' +
          t.shipping_product_not_available +
          "</p></div>",
      ))
    : ((appsStatus = "1"),
      (required_delivery_date = t.required),
      (use_time_option = t.timer_status),
      (a = parseInt(t.week_start)),
      (r = t.date_format),
      (i = oddt_invalid_days(t.invalid_day)),
      (s = oddt_disable_dates(t.extra_no_available)),
      (d = t.time_format),
      (o = oddt_day_text_value(t.current_time_c)),
      (n = t.required_message_date),
      (_ = t.required_message_time),
      (l = jQueryOTD("form[action*='/cart'],form[action='/cart?locale=en']")),
      (m = t.current_month),
      "1" == t.required &&
        ("undefined" != typeof BOLD &&
          void 0 !== BOLD.recurring_orders &&
          void 0 !== BOLD.recurring_orders.app &&
          void 0 !== BOLD.recurring_orders.app.cartWidget &&
          (BOLD.recurring_orders.app.cartWidget.checkoutEnabled = !1),
        "tsm-aquatics.myshopify.com" == OTD_shopName ||
        "petitbowl.myshopify.com" == OTD_shopName ||
        "events-by-daniela.myshopify.com" == OTD_shopName ||
        "gutenmorgenvlbg.myshopify.com" == OTD_shopName ||
        "durian-gao.myshopify.com" == OTD_shopName ||
        "fresh-grinds-cafe.myshopify.com" == OTD_shopName ||
        "okaese.myshopify.com" == OTD_shopName ||
        "birchtree-at-home.myshopify.com" == OTD_shopName ||
        "yippiii.myshopify.com" == OTD_shopName
          ? (jQueryOTD("[name='checkout']").removeAttr("disabled"),
            jQueryOTD("[name='checkout']").length &&
              jQueryOTD("[name='checkout']").click(function (e) {
                check_validation(e, l, n, _, t);
              }))
          : jQueryOTD('a[href="/checkout"]').length
            ? jQueryOTD('a[href="/checkout"]').click(function (e) {
                check_validation(e, l, n, _, t);
              })
            : jQueryOTD(".additional-checkout-button").length
              ? jQueryOTD(".additional-checkout-button").click(function (e) {
                  check_validation(e, l, n, _, t);
                })
              : jQueryOTD("[name='checkout']").length
                ? jQueryOTD("[name='checkout']").click(function (e) {
                    check_validation(e, l, n, _, t);
                  })
                : l.find("[name='checkout']").length &&
                  l.find("[name='checkout']").click(function (e) {
                    check_validation(e, l, n, _, t);
                  })),
      "NULL" != t.timer_status && t.delivery_time
        ? ((c = u = ""),
          (c = oddt_day_text_value(t.auto_current_time_c)),
          (D = t.auto_current_time_c),
          e
            ? (u = date_change_onTimeDel_function(t, D, "default"))
            : ((u = oddt_get_time_slots(t, c, D, t.auto_current_month)),
              1 == d && "" == u[1] && (u = "")),
          !u && e && auto_minday_calculation(t.auto_date, t, i, r, s),
          "" != u ||
            e ||
            (1 == t.cutoff_time_min_day ||
              (1 == t.cutoff_time_status && t.min_day_value),
            auto_minday_calculation(t.auto_date, t, i, r, s),
            (s =
              s +
              "," +
              oddt_get_date_formated(
                new Date(t.current_time_c),
                t.date_format,
              ))),
          oddt_delivery_time_change_action(t.delivery_time_text, e))
        : 0 == oddt_cutOffTimeDate(t, o, t.auto_current_time_c, m) &&
          (auto_minday_calculation(t.auto_date, t, i, r, s),
          (s =
            s +
            "," +
            oddt_get_date_formated(new Date(t.current_time_c), t.date_format))),
      1 == t.enable &&
        1 == t.shipping_status &&
        (jQueryOTD(".appsonrent-dds-main").remove(),
        jQueryOTD(".otd_container").html(t.shipping_html)),
      bindDatePicker(i, a, r, t.months_name, t.days_name, s, t.max_date, t, e));
}
function oddt_delivery_time_change_action(n, _) {
  jQueryOTD(document).on("change", ".iw-otd-deliveryTime", function () {
    (jQueryOTD(
      '.iw-otd-deliveryTime option[value="' + jQueryOTD(this).val() + '"]',
    ).attr("selected", "selected"),
      jQueryOTD(".uiDeliveryTimeVal").val(jQueryOTD(this).val()));
    var e,
      t,
      a,
      r,
      i,
      s = jQueryOTD(this).val(),
      d = jQueryOTD(".uiDeliveryDateVal").val(),
      o = jQueryOTD(".uiDeliveryDayVal").val();
    ("" != s &&
      ((i = "attributes[" + n + "]=" + s + "&update"),
      (e = jQueryOTD(".uiLocationOrderTypeVal").val()),
      (t = (
        null ==
        jQueryOTD(".appsonrent-dds-store-pickup .uiLocationNameVal").val()
          ? jQueryOTD(".uiLocationNameVal")
          : jQueryOTD(".appsonrent-dds-store-pickup .uiLocationNameVal")
      ).val()),
      (a = (
        null ==
        jQueryOTD(".appsonrent-dds-store-pickup .uiLocationAddressVal").val()
          ? jQueryOTD(".uiLocationAddressVal")
          : jQueryOTD(".appsonrent-dds-store-pickup .uiLocationAddressVal")
      ).val()),
      (r = jQueryOTD(".uiLocationIdVal").val()),
      (i =
        "Shipping" == e
          ? "attributes[" +
            OTD_resultJson.delivery_date_text +
            "]=" +
            d +
            "&attributes[" +
            OTD_resultJson.delivery_day_text +
            "]=" +
            o +
            "&attributes[" +
            OTD_resultJson.delivery_time_text +
            "]=" +
            s +
            "&attributes[Order Type]=" +
            (_ ? "" : "Shipping") +
            "&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"
          : "Store Pickup" == e
            ? "attributes[" +
              OTD_resultJson.delivery_date_text +
              "]=" +
              d +
              "&attributes[" +
              OTD_resultJson.delivery_day_text +
              "]=" +
              o +
              "&attributes[" +
              OTD_resultJson.delivery_time_text +
              "]=" +
              s +
              "&attributes[Order Type]=Store Pickup&attributes[Location Id]=" +
              r +
              "&attributes[Location Name]=" +
              t +
              "&attributes[Location Address]=" +
              a +
              "&attributes[Postal Code]=&update"
            : "attributes[" +
              OTD_resultJson.delivery_date_text +
              "]=" +
              d +
              "&attributes[" +
              OTD_resultJson.delivery_day_text +
              "]=" +
              o +
              "&attributes[" +
              OTD_resultJson.delivery_time_text +
              "]=" +
              s),
      jQueryOTD.ajax({
        url: "cart/update.js",
        async: !0,
        data: i,
        type: "POST",
        dataType: "text",
      }),
      (cartParsData = i)),
      "" == s &&
        jQueryOTD(
          ".additional-checkout-buttons, .dynamic-checkout__content",
        ).hide());
  });
}
function oddt_time_dropdown_format_zero(e, t, a, r) {
  var i = e.delivery_time.time,
    s = find_separator_date(e.date_format),
    d = formatDate(e.today_date.date),
    o = (d = d.split("-"))[0],
    n = d[1],
    _ = d[2],
    l = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      s,
      (l = _ + "-" + n + "-" + o),
    ),
    d = convertFixDate(a, "mm-dd-yy"),
    _ = new Date(d),
    n = ("0" + _.getDate()).slice(-2),
    o = ("0" + (_.getMonth() + 1)).slice(-2),
    _ = _.getFullYear(),
    m = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      s,
      (d = n + "-" + o + "-" + _),
    ),
    d = e.select_time_text;
  "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
    (d = e.sp_text_settings.store_pickup_timer_heading);
  var u = t,
    c = e.currentmonthday,
    D = r,
    p = (b = e.currentHr).split("."),
    y = e.cutoff_time_status,
    T = e.cutoff_hour_minute;
  a = parseDate(a);
  for (
    var O = new Date(a).getDate(),
      f = oddt_month_text_value(a),
      h = "",
      a = "",
      d = '<option value="">' + d + "</option>",
      v = i.split(","),
      g = e.delivery_time.time_24,
      b = hide_slots_settings(e, b),
      j = 1 == (j = e.is_show_hide_slot) ? "start" : "end",
      w = 0;
    w < v.length;
    w++
  )
    t == u && parseInt(c) == parseInt(O) && D == f
      ? 0 == y
        ? "start" == j
          ? parseFloat(b) <= parseFloat(v[w]) &&
            (h += '<option value="' + g[w] + '">' + g[w] + "</option>")
          : "end" == j &&
            (parseFloat(b) <= parseFloat(v[w]) ||
              parseFloat(v[w]) == parseFloat(p[0])) &&
            (h += '<option value="' + g[w] + '">' + g[w] + "</option>")
        : (1 == e.cutoff_time_status && m == l) ||
            (1 == e.cutoff_time_status &&
              1 == e.cutoff_time_min_day &&
              m == e.min_date &&
              0 != e.min_day_value)
          ? "start" == j
            ? parseFloat(b) <= parseFloat(v[w]) &&
              parseFloat(b) <= parseFloat(T) &&
              (h += '<option value="' + g[w] + '">' + g[w] + "</option>")
            : "end" == j &&
              (parseFloat(b) <= parseFloat(v[w]) ||
                parseFloat(v[w]) == parseFloat(p[0])) &&
              parseFloat(b) <= parseFloat(T) &&
              (h += '<option value="' + g[w] + '">' + g[w] + "</option>")
          : parseFloat(b) <= parseFloat(v[w]) &&
            (h += '<option value="' + g[w] + '">' + g[w] + "</option>")
      : (h += '<option value="' + g[w] + '">' + g[w] + "</option>");
  return (a = "" != h ? d + h : a);
}
function oddt_time_dropdown_format_one(e, t, a, r) {
  var i = 0,
    s = e.delivery_time,
    d = e.select_time_text,
    o = find_separator_date(e.date_format),
    n = formatDate(e.today_date.date),
    _ = (n = n.split("-"))[0],
    l = n[1],
    m = n[2],
    u = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      o,
      (u = m + "-" + l + "-" + _),
    ),
    c = convertFixDate(a, "mm-dd-yy"),
    D = new Date(c),
    p = ("0" + D.getDate()).slice(-2),
    n = ("0" + (D.getMonth() + 1)).slice(-2),
    m = D.getFullYear(),
    l = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      o,
      (c = p + "-" + n + "-" + m),
    );
  "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
    (d = e.sp_text_settings.store_pickup_timer_heading);
  ((_ = t),
    (D = e.currentmonthday),
    (o = r),
    (p = e.currentHr),
    (n = e.cutoff_time_status),
    (m = e.cutoff_hour_minute));
  a = parseDate(a);
  for (
    var c = new Date(a).getDate(),
      r = oddt_month_text_value(a),
      y = "",
      a = "",
      d = '<option value="">' + d + "</option>",
      T = s.split(","),
      O = 0;
    O < T.length;
    O++
  )
    y += '<option value="' + T[O] + '">' + T[O] + "</option>";
  return (a =
    1 ==
    (i =
      0 == n ||
      t != _ ||
      parseInt(D) != parseInt(c) ||
      o != r ||
      !(
        (1 == e.cutoff_time_status && l == u) ||
        (1 == e.cutoff_time_status &&
          1 == e.cutoff_time_min_day &&
          l == e.min_date &&
          0 != e.min_day_value)
      ) ||
      parseFloat(p) <= parseFloat(m)
        ? 1
        : i)
      ? d + y
      : a);
}
function get24hTime(e) {
  var t = 0 <= (e = String(e).toLowerCase().replace(/\s/g, "")).indexOf("am"),
    a = 0 <= e.indexOf("pm");
  ((e = e.replace("am", "").replace("pm", "")).indexOf(":") < 0 && (e += ":00"),
    t && (e += " am"),
    a && (e += " pm"));
  ((a = new Date("1/1/2011 " + e)),
    (e = function (e) {
      return parseInt(e) < 10 ? "0" + e : String(e);
    }));
  return e(a.getHours()) + ":" + e(a.getMinutes());
}
function oddt_time_dropdown_format_three(e, t, a, r) {
  var i = t,
    s = t,
    d = e.currentmonthday,
    o = r,
    n = e.currentHr,
    _ = e.cutoff_time_status,
    l = e.cutoff_hour_minute,
    m = e.select_time_text,
    u = find_separator_date(e.date_format),
    c = formatDate(e.today_date.date),
    D = (c = c.split("-"))[0],
    p = c[1],
    r = c[2],
    y = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      u,
      (y = r + "-" + p + "-" + D),
    ),
    c = convertFixDate(a, "mm-dd-yy"),
    r = new Date(c),
    p = ("0" + r.getDate()).slice(-2),
    D = ("0" + (r.getMonth() + 1)).slice(-2),
    r = r.getFullYear(),
    T = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      u,
      (c = p + "-" + D + "-" + r),
    );
  "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
    (m = e.sp_text_settings.store_pickup_timer_heading);
  var O = e.delivery_time,
    f = e.time_display_format;
  a = parseDate(a);
  var h,
    v,
    g,
    b = new Date(a).getDate(),
    j = oddt_month_text_value(a),
    a = [];
  h =
    null == e.day_arr
      ? [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Special",
        ]
      : e.day_arr;
  for (
    var w,
      Q,
      x = [],
      A = [],
      I = [],
      S = [],
      J = [],
      n = hide_slots_settings(e, n),
      k = 1 == (k = e.is_show_hide_slot) ? "start" : "end",
      R = 0;
    R < O.length;
    R++
  )
    if (i == h[R])
      for (v = 0; v < O[R].end.length; v++) {
        Q =
          12 == f
            ? ((g = get24hTime(O[R].end[v]).split(":")),
              (temp_start = get24hTime(O[R].start[v]).split(":")),
              (P = O[R].start[v].split(":")),
              (E = O[R].end[v].split(":")),
              4 != P[1].length && 4 != E[1].length
                ? ((w = oddt_convert_24_to_12(P)), oddt_convert_24_to_12(E))
                : ((w = O[R].start[v]), O[R].end[v]))
            : ((g = O[R].end[v].split(":")),
              (temp_start = O[R].start[v].split(":")),
              (w = O[R].start[v]),
              O[R].end[v]);
        var F,
          L,
          C = O[R].pre[v],
          N = O[R].post[v],
          M = O[R].to[v],
          q = O[R].limit_status[v],
          P = O[R].number_orders[v],
          E = 0;
        (t == s && parseInt(d) == parseInt(b) && o == j
          ? 0 == _
            ? "start" == k && 1 == e.hide_slots_settings
              ? parseFloat(n) <= parseFloat(temp_start[0]) &&
                parseFloat(n) <= parseFloat(g[0]) &&
                ((L = C + " " + w + " " + M + " " + Q + " " + N),
                x.push((F = w + "-" + Q)),
                A.push(L),
                1 == q && 0 == P && J.push(F),
                I.push(q),
                S.push(P))
              : "end" == k && 1 == e.hide_slots_settings
                ? parseFloat(n) <= parseFloat(g[0]) &&
                  ((L = C + " " + w + " " + M + " " + Q + " " + N),
                  x.push((F = w + "-" + Q)),
                  A.push(L),
                  1 == q && 0 == P && J.push(F),
                  I.push(q),
                  S.push(P))
                : (E = 1)
            : "start" == k && 1 == e.hide_slots_settings
              ? (1 == e.cutoff_time_status && T == y) ||
                (1 == e.cutoff_time_status &&
                  1 == e.cutoff_time_min_day &&
                  T == e.min_date &&
                  0 != e.min_day_value)
                ? parseFloat(e.currentHr) <= parseFloat(temp_start[0]) &&
                  parseFloat(e.currentHr) <= parseFloat(g[0]) &&
                  parseFloat(e.currentHr) <= parseFloat(l) &&
                  ((L = C + " " + w + " " + M + " " + Q + " " + N),
                  x.push((F = w + "-" + Q)),
                  A.push(L),
                  1 == q && 0 == P && J.push(F),
                  I.push(q),
                  S.push(P))
                : parseFloat(e.currentHr) <= parseFloat(temp_start[0]) &&
                  ((L = C + " " + w + " " + M + " " + Q + " " + N),
                  x.push((F = w + "-" + Q)),
                  A.push(L),
                  1 == q && 0 == P && J.push(F),
                  I.push(q),
                  S.push(P))
              : "end" == k && 1 == e.hide_slots_settings
                ? (1 == e.cutoff_time_status && T == y) ||
                  (1 == e.cutoff_time_status &&
                    1 == e.cutoff_time_min_day &&
                    T == e.min_date &&
                    0 != e.min_day_value)
                  ? parseFloat(e.currentHr) <= parseFloat(g[0]) &&
                    parseFloat(e.currentHr) <= parseFloat(l) &&
                    ((L = C + " " + w + " " + M + " " + Q + " " + N),
                    x.push((F = w + "-" + Q)),
                    A.push(L),
                    1 == q && 0 == P && J.push(F),
                    I.push(q),
                    S.push(P))
                  : parseFloat(e.currentHr) <= parseFloat(g[0]) &&
                    ((L = C + " " + w + " " + M + " " + Q + " " + N),
                    x.push((F = w + "-" + Q)),
                    A.push(L),
                    1 == q && 0 == P && J.push(F),
                    I.push(q),
                    S.push(P))
                : (1 == e.cutoff_time_status && T == y) ||
                    (1 == e.cutoff_time_status &&
                      1 == e.cutoff_time_min_day &&
                      T == e.min_date &&
                      0 != e.min_day_value)
                  ? 0 == e.hide_slots_settings &&
                    parseFloat(e.currentHr) <= parseFloat(l) &&
                    ((L = C + " " + w + " " + M + " " + Q + " " + N),
                    x.push((F = w + "-" + Q)),
                    A.push(L),
                    1 == q && 0 == P && J.push(F),
                    I.push(q),
                    S.push(P))
                  : (E = 1)
          : (E = 1),
          E &&
            ((L = C + " " + w + " " + M + " " + Q + " " + N),
            x.push((F = w + "-" + Q)),
            A.push(L),
            1 == q && 0 == P && J.push(F),
            I.push(q),
            S.push(P)));
      }
  if (
    (a.push(x.toString().split(",")),
    a.push(A.toString().split(",")),
    a.push(I.toString().split(",")),
    a.push(S.toString().split(",")),
    "" != a[0])
  ) {
    var V = '<option value="">' + m + "</option>",
      $ = order_limit_time_format(
        e,
        "" == jQueryOTD(".uiDeliveryDateVal").val() ||
          null == jQueryOTD(".uiDeliveryDateVal").val()
          ? e.min_date
          : jQueryOTD(".uiDeliveryDateVal").val(),
        e.all_orders,
        a[0],
        a[1],
        a[2],
        a[3],
      );
    J.forEach(function (e, t) {
      -1 < jQueryOTD.inArray(e, $[0]) &&
        ((e = $[0].indexOf(e)),
        delete $[0][e],
        delete $[1][e],
        delete $[2][e],
        delete $[3][e]);
    });
    for (var H = 0; H < $[1].length; H++)
      void 0 !== $[0][H] &&
        (V += '<option value="' + $[0][H] + '">' + $[1][H] + "</option>");
    a = V;
  }
  return a;
}
function dateFormatConvert_new(e, t, a, r, i) {
  ((e = e.toLowerCase().split(a)), (i = i.split(a)));
  ((i[e[0]] = i[0]), (i[e[1]] = i[1]), (i[e[2]] = i[2]));
  a = t.toLowerCase().split(a);
  return ((newDate = i[a[0]] + r + i[a[1]] + r + i[a[2]]), newDate);
}
function order_limit_time_format(e, t, a, r, i, s, d) {
  for (
    var o = [],
      n = e.date_format,
      e = n.charAt(2),
      t = dateFormatConvert_new(n, "yy" + e + "mm" + e + "dd", "" + e, "-", t),
      _ = 0;
    _ < a.length;
    _++
  ) {
    var l = a[_].delivery_date,
      m = a[_].delivery_time;
    t == l && o.push(m);
  }
  if (o.length) {
    var u = [];
    o.forEach(function (e) {
      u[e] = (u[e] || 0) + 1;
    });
    for (var c, D = 0; D < r.length; D++)
      1 == s[D] &&
        ((timer = null != u[r[D]] ? u[r[D]] : ""),
        "" != timer &&
          timer >= d[D] &&
          (delete r[D], delete i[D], delete s[D], delete d[D]));
    return (((c = [])[0] = r), (c[1] = i), (c[2] = s), (c[3] = d), c);
  }
  return (((c = [])[0] = r), (c[1] = i), (c[2] = s), (c[3] = d), c);
}
function auto_minday_calculation(e, t, a, r, i, s = "") {
  var d,
    o,
    e = t.temp_auto_date,
    n = t.temp_auto_current_week_day,
    _ = r.charAt(2),
    _ = dateFormatConvert_new(r, "mm" + _ + "dd" + _ + "yy", "" + _, "/", e),
    l = new Date(_);
  for (
    "otd_shipping" == s && (d = l.setDate(l.getDate() - 1)),
      "otd_shipping" != s &&
        ((d = l.setDate(l.getDate() + 1)),
        (o = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r)),
        n++,
        OTD_resultJson.auto_current_week_day++);
    -1 < jQueryOTD.inArray(n, a);
  )
    ((d = l.setDate(l.getDate() + 1)),
      (o = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r)),
      (n = new Date(o).getDay()));
  for (; -1 < jQueryOTD.inArray(e, i); )
    for (
      d = l.setDate(l.getDate() + 1),
        o = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r),
        n = new Date(o).getDay();
      -1 < jQueryOTD.inArray(n, a);
    )
      ((d = l.setDate(l.getDate() + 1)),
        (o = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r)),
        (n = new Date(o).getDay()));
  t.auto_date = e;
}
function oddt_before_show_days(e, t, a, r, i) {
  var s = e.getDay(),
    i = (new Date(e), i.current_time_c, i.active_addon);
  return -1 < t.indexOf(s)
    ? [!1, "booked", ""]
    : (jQueryOTD.inArray("2", i), [!0, "", ""]);
}
function get_order_data_of_month(t, e) {
  jQueryOTD.ajax({
    type: "POST",
    url: SITE_FILE_URL,
    data: {
      method_name: "get_selected_month_order",
      shop: OTD_shopName,
      date: e,
      store_client_id: t.store_client_id,
    },
    dataType: "json",
    success: function (e) {
      t.order_data = e;
    },
    error: function () {
      console.log("Error on get data of selected month");
    },
  });
}
function bindDatePicker(t, e, a, r, i, s, d, o, n) {
  var _ = o.auto_date;
  OTD_resultJson = o;
  var l = a.replace("yy", "yyyy"),
    r = r.split(","),
    m = [];
  jQueryOTD.each(r, function (e, t) {
    m.push(t.substring(0, 3));
  });
  var u,
    i = i.split(","),
    c = [],
    D = [];
  (jQueryOTD.each(i, function (e, t) {
    (c.push(t.substring(0, 3)), D.push(t));
  }),
    (jQueryOTD.fn.bootstrapDP.dates.en = {
      months: r,
      days: i,
      daysShort: D,
      daysMin: D,
      monthsShort: m,
      titleFormat: "MM yyyy",
    }),
    jQueryOTD(".uiDeliveryCalendar")
      .bootstrapDP({
        container: jQueryOTD('dialog.dialog-drawer')[0],
        format: l,
        startDate: _,
        endDate:
          0 < o.max_day
            ? new Date(
                new Date().setDate(new Date().getDate() + (o.max_day - 1)),
              )
            : null,
        datesDisabled: OTD_resultJson.extra_no_available,
        daysOfWeekDisabled: t,
        weekStart: e,
        autoclose: !0,
        orientation: "bottom left",
        beforeShowDay: function (e) {
          return oddt_before_show_days(e, t, s, a, o);
        },
      })
      .on("changeMonth", function (e) {
        var t, a, r, i;
        n
          ? ((i = ("0" + (a = new Date(e.date)).getDate()).slice(-2)),
            (r = ("0" + (a.getMonth() + 1)).slice(-2)),
            (t = a.getFullYear()),
            get_order_data_of_month(OTD_resultJson, t + "-" + r + "-" + i))
          : ((r = ("0" + ((a = new Date(e.date)).getMonth() + 1)).slice(-2)),
            (i = a.getFullYear()),
            1 == OTD_resultJson.timer_status &&
              1 == OTD_resultJson.time_format &&
              ((e = "01/" + r + "/" + i),
              (a =
                null != OTD_resultJson.location_id
                  ? OTD_resultJson.location_id
                  : "IS NULL"),
              (r = 0),
              "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
                ((a = jQueryOTD(".uiLocationIdVal").val()), (r = 1)),
              ((i = {}).shop = OTD_shopName),
              (i.oddShopInfo = OTD_resultJson.oddShopInfo),
              (i.min_date = e),
              (i.extra_no_available = OTD_resultJson.extra_no_available),
              (i.timer_status = OTD_resultJson.timer_status),
              (i.date_format = OTD_resultJson.date_format),
              (i.time_format = OTD_resultJson.time_format),
              (i.delivery_time = OTD_resultJson.time_format_value),
              (i.location_id = a),
              (i.order_type = r),
              (i.method_name = "dds_addon_order_data"),
              jQueryOTD.ajax({
                type: "POST",
                url: SITE_FILE_URL,
                data: i,
                async: !1,
                success: function (e) {
                  ((addonOrderData = JSON.parse(e)),
                    (s =
                      "" != s
                        ? s + "," + addonOrderData.extra_no_available
                        : addonOrderData.extra_no_available),
                    (OTD_resultJson.extra_no_available = s),
                    (OTD_resultJson.all_orders_status =
                      addonOrderData.all_orders_status),
                    (OTD_resultJson.all_orders = addonOrderData.all_orders));
                },
              })));
      })
      .on("changeDate", function (e) {
        e = new Date(e.date);
        date_select(
          ("0" + e.getDate()).slice(-2) +
            "-" +
            ("0" + (e.getMonth() + 1)).slice(-2) +
            "-" +
            e.getFullYear(),
          a,
          o,
          n,
        );
      }),
    1 == OTD_resultJson.cal_type &&
      jQueryOTD(".identixweb-order-delivery-datepicer-icon").bind(
        "click",
        ".order-calendar-button-click",
        function (e) {
          jQueryOTD(e.delegateTarget).find(".uiDeliveryCalendar").focus();
        },
      ),
    setTimeout(function () {
      (jQueryOTD(".appsonrent-dds-local-delivery-preloader").hide(),
        jQueryOTD(".appsonrent-dds-main").show(),
        jQueryOTD(".order-delivery-date-local-delivery").show(),
        jQueryOTD(".appsonrent-dds-store-pickup").show(),
        jQueryOTD(
          ".store_loader .identixweb-order-delivery-date-store-pickup",
        ).show());
    }, 300),
    (OTD_map_load = 0) == OTD_map_load &&
      1 == jQueryOTD(".storePickupTab").hasClass("active_tab") &&
      null != OTD_resultJson.google_map_status &&
      1 == OTD_resultJson.google_map_status &&
      (u = setInterval(function () {
        0 < jQueryOTD("#oddGoogleMap").length &&
          (initMap(OTD_resultJson), clearInterval(u));
      }, 1e3)));
}
function date_select(e, t, a, r) {
  var i,
    s,
    d = e,
    o = "",
    n = oddt_month_text_value(parseDate(a.current_time_c)),
    _ = find_separator_date(t);
  ((e =
    "dd.mm.yy" == t || "dd/mm/yy" == t || "dd-mm-yy" == t
      ? ((i = dateFormatConvert("dd-mm-yy", t, "-", _, d)),
        (i =
          "dd.mm.yy" == OTD_resultJson.convert_date_format
            ? i.replace(/[/,\s]/g, ".").replace(/[-,\s]/g, ".")
            : i),
        (s = oddt_day_text_value(
          convertFixDate(
            (l = dateFormatConvert("yy-mm-dd", t, "-", _, d)),
            "yy-mm-dd",
          ),
        )),
        oddt_day_text_value_DAY(convertFixDate(l, "yy-mm-dd")))
      : ((i = dateFormatConvert("dd-mm-yy", t, "-", _, d)),
        (l = dateFormatConvert("dd-mm-yy", t, "-", _, d)),
        (s = oddt_day_text_value(convertFixDate(i, t))),
        oddt_day_text_value_DAY(convertFixDate(i, t)))),
    jQueryOTD(".uiDeliveryDateVal").val(i),
    jQueryOTD(".uiDeliveryDayVal").val(s),
    jQueryOTD(".deliveryTime").empty(),
    "NULL" === a.timer_status || r || (o = oddt_get_time_slots(a, s, l, n)),
    "NULL" !== a.timer_status &&
      r &&
      (o = date_change_onTimeDel_function(a, l, "changeDate")),
    jQueryOTD(".iw-otd-deliveryTime")
      .html(o)
      .removeAttr("disabled")
      .removeClass("disable_time_slot"),
    (_ =
      "1" == a.timer_status
        ? "attributes[" +
          a.delivery_date_text +
          "]=" +
          i +
          "&attributes[" +
          a.delivery_day_text +
          "]=" +
          e +
          "&attributes[" +
          a.delivery_time_text +
          "]&update"
        : "attributes[" +
          a.delivery_date_text +
          "]=" +
          i +
          "&attributes[" +
          a.delivery_day_text +
          "]=" +
          e +
          "&update"));
  var d = jQueryOTD(".uiLocationOrderTypeVal").val(),
    t = jQueryOTD(".uiLocationNameVal").val(),
    n = jQueryOTD(".uiLocationAddressVal").val(),
    l = jQueryOTD(".uiLocationIdVal").val();
  ("Shipping" == d
    ? ((o = r ? "" : "Shipping"),
      r && jQueryOTD(".uiLocationOrderTypeVal").val(""),
      (_ =
        "1" == a.timer_status
          ? "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            s +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=" +
            o +
            "&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"
          : "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            e +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=" +
            o +
            "&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"))
    : "Store Pickup" == d &&
      (_ =
        "1" == a.timer_status
          ? "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            s +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=Store Pickup&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"
          : "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            e +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=Store Pickup&attributes[Location Id]=" +
            l +
            "&attributes[Location Name]=" +
            t +
            "&attributes[Location Address]=" +
            n +
            "&attributes[Postal Code]=&update"),
    jQueryOTD(
      '.iw-otd-deliveryTime option[value="' + a.cart_delivery_time + '"]',
    ).attr("selected", "selected"),
    jQueryOTD(".iw-otd-deliveryTime").trigger("change"),
    jQueryOTD.ajax({
      url: "/cart/update.js",
      data: _,
      type: "POST",
      dataType: "text",
      async: !1,
    }));
}
function oddt_convert_24_to_12(e) {
  var t;
  return (
    (t = "00" == e[0] ? 12 : e[0]),
    12 < e[0]
      ? parseInt(e[0] - 12) < 10
        ? "0" + parseInt(e[0] - 12) + ":" + e[1] + "PM"
        : parseInt(e[0] - 12) + ":" + e[1] + "PM"
      : 12 == e[0]
        ? parseInt(e[0]) + ":" + e[1] + "PM"
        : t + ":" + e[1] + "AM"
  );
}
function oddt_get_date_formated(e, t) {
  var a, r;
  ((a =
    parseInt(e.getMonth() + 1) < 10
      ? "0" + parseInt(e.getMonth() + 1)
      : parseInt(e.getMonth() + 1)),
    (r = e.getDate() < 10 ? "0" + e.getDate() : e.getDate()));
  var i = e.getFullYear(),
    s = "";
  switch (t) {
    case "dd/mm/yy":
      s = r + "/" + a + "/" + i;
      break;
    case "dd/yy/mm":
      s = r + "/" + i + "/" + a;
      break;
    case "mm/dd/yy":
      s = a + "/" + r + "/" + i;
      break;
    case "mm/yy/dd":
      s = a + "/" + i + "/" + r;
      break;
    case "yy/dd/mm":
      s = i + "/" + r + "/" + a;
      break;
    case "yy/mm/dd":
      s = i + "/" + a + "/" + r;
      break;
    case "dd-mm-yy":
      s = r + "-" + a + "-" + i;
      break;
    case "dd-yy-mm":
      s = r + "-" + i + "-" + a;
      break;
    case "mm-dd-yy":
      s = a + "-" + r + "-" + i;
      break;
    case "mm-yy-dd":
      s = a + "-" + i + "-" + r;
      break;
    case "yy-dd-mm":
      s = i + "-" + r + "-" + a;
      break;
    case "yy-mm-dd":
      s = i + "-" + a + "-" + r;
  }
  return s;
}
function hulkappsCheckoutClick() {
  if ("1" != on_time_appsStatus) return !0;
  var e = !1;
  return (
    "1" == on_time_use_time_option
      ? (("1" == on_time_required_delivery_date &&
          jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val() &&
          jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val()) ||
          "0" == on_time_required_delivery_date) &&
        (e = !0)
      : (("1" == on_time_required_delivery_date &&
          jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()) ||
          "0" == on_time_required_delivery_date) &&
        (e = !0),
    e
  );
}
function oddt_day_text_value_DAY(e) {
  var t = OTD_delivery_days,
    a = parseDate(e);
  new Date(a);
  return t[e.getDay()];
}
(Shopify.Checkout &&
  void 0 !== Shopify.Checkout.OrderStatus &&
  (("thank_you" != Shopify.Checkout.page && !Shopify.checkout.order_id) ||
    (((OTD_data = {}).shop = Shopify.shop),
    (OTD_data.method_name = "select_settings_text"),
    (OTD_data.order_id = Shopify.checkout.order_id),
    jQueryOTD.ajax({
      type: "POST",
      url: SITE_FILE_URL,
      data: OTD_data,
      dataType: "json",
      success: function (e) {
        var t, a;
        null != e.settings.show_on_thankyou &&
          "1" == e.settings.show_on_thankyou &&
          void 0 !== e.orders &&
          "success" == e.msg &&
          ((t = e.orders.delivery_date),
          void 0 === e.orders.api_call &&
            ((a = find_separator_date(e.settings.date_format)),
            (t = dateFormatConvert(
              "yy-mm-dd",
              e.settings.date_format,
              "-",
              "" + a,
              t,
            ))),
          (a = '<div class="content-box"><div class="content-box__row">'),
          "" != e.settings.box_title_text &&
            (1 == e.orders.order_type
              ? (a +=
                  '<h2 class="os-step__title">' +
                  e.sp_title_text_settings +
                  "</h2>")
              : (a +=
                  '<h2 class="os-step__title">' +
                  e.settings.box_title_text +
                  "</h2>")),
          "" != e.orders.delivery_time
            ? (a +=
                '<div class="os-step__special-description"><p class="iweb-dt-delivery_date"><strong>' +
                e.settings.delivery_date +
                " : </strong> <span>" +
                t +
                '</span></p><p class="iweb-dt-delivery_time" style="margin-top:0"><strong>' +
                e.settings.delivery_time +
                " : </strong> <span>" +
                e.orders.delivery_time +
                "</span></p>")
            : (a +=
                '<div class="os-step__special-description"><p class="iweb-dt-delivery_date"><strong>' +
                e.settings.delivery_date +
                " : </strong> <span>" +
                t +
                "</span></p>"),
          1 == e.orders.order_type &&
            (a +=
              '<p class="iweb-dt-delivery_address"><strong> Store Pickup Address : </strong> <span>' +
              e.orders.location_address +
              "</span></p>"),
          (a += "</div></div></div>"),
          window.Checkout.$(
            ".content .section:nth-child(3) .content-box:first-child",
          ).after(a),
          window.Checkout.$(".iweb-dt-delivery_date").length ||
            window.Checkout.$(
              ".content .section:nth-child(2) .content-box:first-child",
            ).after(a));
      },
    }))),
  window.RevyBundle &&
    (window.RevyBundle.api.checkoutValidator = function () {
      if ("1" != on_time_appsStatus) return !0;
      var e = !1;
      return (
        "1" == on_time_use_time_option
          ? (("1" == on_time_required_delivery_date &&
              "" != jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val() &&
              "" != jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val()) ||
              "0" == on_time_required_delivery_date) &&
            (e = !0)
          : (("1" == on_time_required_delivery_date &&
              "" != jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()) ||
              "0" == on_time_required_delivery_date) &&
            (e = !0),
        e
      );
    }));
